@switch (currentView) { @case ('dashboard') {
<div>
  <div class="overview-header overview-animate d-flex justify-content-between align-items-center mt-3 px-5">
    <div class="overview-left">
      <h1>Overview</h1>
      <p>See Your Latest Overview Of Your <strong>{{this.project}}</strong> Leads</p>
    </div>
  </div>
  <div class="border-btm"></div>
</div>

<div class="overview-right position-absolute d-flex align-items-center">
  <div class="kanban-view-btn" role="button" tabindex="0" (click)="goToKanban()">
    <img src="/assets/leads/kanban.png" width="22" height="22" alt="Kanban view" />
    <span>Go to Kanban</span>
  </div>

  <div class="fx-date-range-wrapper d-flex align-items-center gap-2">
    <!-- Date Range Picker -->
    <div class="fx-date-range-container position-relative">
      <input class="fx-date-range tag" type="text" matInput ngxDaterangepickerMd [locale]="locale" [drops]="'down'"
        [opens]="'left'" [showCustomRangeLabel]="false" [alwaysShowCalendars]="true"
        [keepCalendarOpeningWithRange]="true" [showCancel]="true" [startKey]="'startDate'" [endKey]="'endDate'"
        [autoApply]="true" autocomplete="off" name="daterange" [(ngModel)]="selectedDateRange"
        (datesUpdated)="onDateSelected($event)" (hide)="onDatepickerHide()" placeholder="Search by date range"
        readonly />
      <i class="far fa-calendar-alt calendar-icon"></i>
      @if(isFilteredView) {
      <button class="clear-btn" (click)="clearDateFilter()" title="Clear date filter">
        <i class="fas fa-times"></i>
      </button>
      }
    </div>
  </div>

  <img class="bubble-img position-absolute" src="../../../assets/leads/bubbles.png" alt="bubbles" />
</div>
<!-- CARDS ROW -->
<div class="cards-floating">
  <!-- CARD 1 -->
  <div class="stat-card animate-card">
    <div class="card-inner">
      <!-- CARD HEADER -->
      <div class="card-head d-flex align-items-center">
        <div class="icon-box dark">
          <img src="../../../assets/leads/recent-lead-icon.png" alt="recent-lead-icon" />
        </div>
        <span class="card-title ml-2">Total Leads</span>
      </div>

      <!-- CONTENT -->
      @if (isStatsLoading) {

      <!-- SHIMMER -->
      <div class="card-shimmer pt-4 d-flex justify-content-between align-items-center">
        <div>
          <div class="shimmer-count shimmer"></div>
          <div class="shimmer-chart shimmer mt-3"></div>
        </div>
        <div>
          <div class="shimmer-text shimmer mt-3"></div>
        </div>
      </div>

      } @else {

      <!-- REAL DATA -->
      <div class="card-content d-flex justify-content-between align-items-center pt-4">
        <h2>{{ totalsLeadsCounts }}</h2>

        <div class="mini-chart chart-blue">
          <img src="../../../assets/leads/recent-lead-graph.png" alt="recent-lead" />
        </div>
      </div>

      <p class="growth-text">
        @if (totalLeadsTrend?.type === 'neutral') {
        <span class="neutral">No change from last week</span>
        } @else {
        <span class="value" [class.green]="totalLeadsTrend?.type === 'positive'"
          [class.red]="totalLeadsTrend?.type === 'negative'">
          {{ totalLeadsTrend?.value }}
        </span>
        {{ totalLeadsTrend?.text }}
        }
      </p>

      }
    </div>
  </div>

  <!-- CARD 2 -->
  <div class="stat-card animate-card">
    <div class="card-inner">
      <div class="card-head d-flex align-items-center">
        <div class="icon-box dark">
          <img src="../../../assets/leads/progress-lead-icon.png" alt="progress-lead-icon" />
        </div>
        <span class="card-title ml-2">In progress Leads</span>
      </div>
      @if (isStatsLoading) {

      <!-- SHIMMER -->
      <div class="card-shimmer pt-4 d-flex justify-content-between align-items-center">
        <div>
          <div class="shimmer-count shimmer"></div>
          <div class="shimmer-chart shimmer mt-3"></div>
        </div>
        <div>
          <div class="shimmer-text shimmer mt-3"></div>
        </div>
      </div>

      } @else {
      <div class="card-content d-flex justify-content-between align-items-center pt-4">
        <h2>{{ this.totalInProgressCount }}</h2>
        <div class="mini-chart chart-blue">
          <img class="progress-graph" src="../../../assets/leads/progress-lead-graph.png" alt="progress-lead" />
        </div>
      </div>

      <p class="growth-text">
        @if (progressLeadTrend?.type === 'neutral') {
        <span class="neutral">No change from last week</span>
        } @else {
        <span class="value" [class.green]="progressLeadTrend?.type === 'positive'"
          [class.red]="progressLeadTrend?.type === 'negative'">
          {{ progressLeadTrend?.value }}
        </span>
        {{ progressLeadTrend?.text }}
        }
      </p>

      }
    </div>
  </div>

  <!-- CARD 3 -->
  <div class="stat-card animate-card">
    <div class="card-inner">
      <div class="card-head d-flex align-items-center">
        <div class="icon-box dark">
          <img src="../../../assets/leads/converted-lead-icon.png" alt="converted-lead-icon" />
        </div>
        <span class="card-title ml-2">Converted Leads</span>
      </div>
      @if (isStatsLoading) {

      <!-- SHIMMER -->
      <div class="card-shimmer pt-4 d-flex justify-content-between align-items-center">
        <div>
          <div class="shimmer-count shimmer"></div>
          <div class="shimmer-chart shimmer mt-3"></div>
        </div>
        <div>
          <div class="shimmer-text shimmer mt-3"></div>
        </div>
      </div>

      } @else {
      <div class="card-content d-flex justify-content-between align-items-center pt-4">
        <h2>{{ this.totalConvertedLeadsCount }}</h2>
        <div class="mini-chart chart-blue">
          <img src="../../../assets/leads/converted-lead-graph.png" alt="converted-lead" />
        </div>
      </div>

      <p class="growth-text">
        @if (convertedLeadTrend?.type === 'neutral') {
        <span class="neutral">No change from last week</span>
        } @else {
        <span class="value" [class.green]="convertedLeadTrend?.type === 'positive'"
          [class.red]="convertedLeadTrend?.type === 'negative'">
          {{ convertedLeadTrend?.value }}
        </span>
        {{ convertedLeadTrend?.text }}
        }
      </p>

      }
    </div>
  </div>

  <!-- CARD 4 -->
  <div class="stat-card animate-card">
    <div class="card-inner">
      <div class="card-head d-flex align-items-center">
        <div class="icon-box dark">
          <img src="../../../assets/leads/lost-lead-icon.png" alt="lost-lead-icon" />
        </div>
        <span class="card-title ml-2">Lost Leads</span>
      </div>
      @if (isStatsLoading) {

      <!-- SHIMMER -->
      <div class="card-shimmer pt-4 d-flex justify-content-between align-items-center">
        <div>
          <div class="shimmer-count shimmer"></div>
          <div class="shimmer-chart shimmer mt-3"></div>
        </div>
        <div>
          <div class="shimmer-text shimmer mt-3"></div>
        </div>
      </div>

      } @else {
      <div class="card-content d-flex justify-content-between align-items-center pt-4">
        <h2>{{ this.totalLostLeadsCount }}</h2>
        <div class="mini-chart chart-blue">
          <img src="../../../assets/leads/lost-lead-graph.png" alt="lost-lead" />
        </div>
      </div>
      <p class="growth-text">
        @if (lostLeadTrend?.type === 'neutral') {
        <span class="neutral">No change from last week</span>
        } @else {
        <span class="value" [class.green]="lostLeadTrend?.type === 'positive'"
          [class.red]="lostLeadTrend?.type === 'negative'">
          {{ lostLeadTrend?.value }}
        </span>
        {{ lostLeadTrend?.text }}
        }
      </p>

      }
    </div>
  </div>
</div>

<!-- SALES LEADS DASHBOARD -->
@if(!loggedInUser){
<div class="user-progress-banner">
  <div class="user-profile d-flex">

    <!-- LEFT USER CARD -->
    <div class="user-card d-flex" [ngClass]="{
      'user-card-loading': isUserCardLoading,
      'progress-good': userProgress === 'Good' && !isUserCardLoading,
      'progress-average': userProgress === 'Average' && !isUserCardLoading,
      'progress-bad': userProgress === 'Bad' && !isUserCardLoading
    }">
      <div>
        <!-- COMMENT -->
        @if (isUserCardLoading) {
        <div class="shimmer-name shimmer mt-5"></div>
        <div class="shimmer-role shimmer mt-2"></div>
        } @else {
        @switch (userProgress) {
        @case ('Good') {
        <p class="grade-cmt pr-1">Yahh!! You are doing great ✨</p>
        }
        @case ('Average') {
        <p class="grade-cmt pr-1">Oops!! Don't worry you can do it 💪</p>
        }
        @default {
        <p class="grade-cmt pr-1">Oops!! Don't worry you can do it 🤞</p>
        }
        }
        }

        <!-- USER NAME -->
        @if (isUserCardLoading) {
        <div class="shimmer-name shimmer mt-2"></div>
        } @else {
        <h3>{{ salesUserName }}</h3>
        }

        <!-- ROLE -->
        @if (isUserCardLoading) {
        <div class="shimmer-role shimmer mt-2"></div>
        } @else {
        <p class="designation">{{ role }}</p>
        }
      </div>

      <!-- RIGHT IMAGE / AVATAR -->
      @if (isUserCardLoading) {
      <div class="shimmer-img shimmer mt-4"></div>
      } @else {
      <!-- Glass -->
      <img class="user-glass" src="../../../../assets/leads/user-profile-card.png" alt="glass-bg" />

      <!-- Avatar -->
      <img class="user-avatar" [src]="
          userProgress === 'Good'
            ? '../../../../assets/leads/user-avatar-happy.png'
            : userProgress === 'Average'
              ? '../../../../assets/leads/avg-avatar.png'
              : '../../../../assets/leads/user-avatar-sad.png'
        " alt="user-avatar" />
      }
    </div>

    <!-- RIGHT PROGRESS TRACK -->
    <div class="user-progress-track">

      <div class="d-flex justify-content-between mt-2">
        <h4>
          Track All Your Leads In One Place, From
          <span>First Contact To Conversion</span>
        </h4>

        <!-- PROGRESS BADGE -->
        <div class="grade-label pr-2" [ngClass]="{
          'badge-good': userProgress === 'Good',
          'badge-average': userProgress === 'Average',
          'badge-bad': userProgress === 'Bad'
        }">
          <p class="mb-0 mt-2">Your Progress</p>
          <h5>{{ userProgress }}</h5>
        </div>
      </div>

      <!-- PROGRESS BARS -->
      <div class="progress-bar-container d-flex align-items-center w-100 mt-5" [ngClass]="{
        'bar-good': userProgress === 'Good',
        'bar-average': userProgress === 'Average',
        'bar-bad': userProgress === 'Bad'
      }">

        @if (isLeadDataLoading) {

        <!-- SHIMMER -->
        <div class="progress-skeleton w-100 d-flex align-items-center">
          @for (i of [1, 2, 3]; track i) {
          <div class="skeleton-row mt-3">
            <div class="skeleton-label shimmer"></div>
            <div class="skeleton-bar shimmer mt-2"></div>
          </div>
          }
        </div>

        } @else {

        @for (item of leadData; track item) {
        <div class="progress-row mt-3">

          <div class="label">
            <span class="dot" [style.background]="item.color"></span>
            <p class="mb-0">{{ item.label }}</p>
          </div>

          <div class="d-flex align-items-center mt-2">
            <div class="progress-bar">
              <div class="fill" [style.width.%]="item.value" [style.background]="item.color"></div>
            </div>
            <span class="percent ml-2">{{ item.value }}%</span>
          </div>

        </div>
        }

        }
      </div>
    </div>

  </div>

  <!-- FOLLOW-UP REMINDERS SECTION -->
  <div class="follow-up-reminders-container mt-5">
    <div class="follow-up-reminders-header">
      <div class="follow-up-reminders-title-group">
        <div class="follow-up-reminders-icon-wrapper">
          <i class="fas fa-bell"></i>
        </div>
        <h3 class="follow-up-reminders-title">
          Follow-up Reminders
        </h3>
      </div>

      <div class="reminders-tabs-wrapper d-flex align-items-center flex-wrap" style="gap: 12px;">
        <!-- Status Filter Tabs -->
        <ul class="reminders-tabs">
          @for (tab of remindersTabs; track tab) {
          <li [class.active]="activeReminderTab === tab" (click)="onReminderTabChange(tab)">
            {{ tab }}
            <span class="tab-count-badge">{{ getReminderCount(tab) }}</span>
          </li>
          }
        </ul>
      </div>
    </div>

    <!-- Content Area -->
    <div class="reminders-content-area">
      <!-- Loading State -->
      @if (isRemindersLoading && (!displayedReminders || displayedReminders.length === 0)) {
      <div class="reminders-loading-state">
        <div class="spinner-border text-primary mb-3" role="status" style="width: 2rem; height: 2rem;">
          <span class="sr-only">Loading reminders...</span>
        </div>
        <p class="text-muted mb-0" style="font-size: 13.5px; font-weight: 500;">
          Loading {{ activeReminderTab.toLowerCase() }} reminders...
        </p>
      </div>
      }
      <!-- Populated State -->
      @else if (displayedReminders && displayedReminders.length > 0) {
      <div class="reminders-grid">
        @for (item of displayedReminders; track item._id || item.id || $index) {
        <div class="reminder-card">
          <!-- Card Header: Lead Name + Status Badge -->
          <div class="reminder-card-header">
            <div>
              <div class="d-flex align-items-center" style="gap: 8px;">
                @if (item.companyProfileImg) {
                <img [src]="item.companyProfileImg" class="rounded-circle" width="22" height="22"
                  style="object-fit: cover; flex-shrink: 0;" />
                }
                <h4 class="reminder-lead-name" title="View lead details" (click)="openLeadFromReminder(item)">
                  {{ getReminderLeadName(item) }}
                </h4>
              </div>
              @if (getReminderLeadPhone(item)) {
              <span class="text-muted d-block" style="font-size: 12px; margin-top: 2px;">
                <i class="fas fa-phone-alt mr-1" style="font-size: 10px; color: #94a3b8;"></i>{{
                getReminderLeadPhone(item) }}
              </span>
              }
            </div>

            <span class="reminder-badge"
              [style.background]="getReminderStatusBadge(item.status || activeReminderTab).bg"
              [style.color]="getReminderStatusBadge(item.status || activeReminderTab).color"
              [style.border]="'1px solid ' + getReminderStatusBadge(item.status || activeReminderTab).border">
              <i [class]="getReminderStatusBadge(item.status || activeReminderTab).icon" style="font-size: 10.5px;"></i>
              {{ item.status || activeReminderTab }}
            </span>
          </div>

          <!-- Note / Target Status Meta Content -->
          @if (item.note || item.notes || item.description || item.targetStatus || item.projectTab || item.source) {
          <div class="reminder-note-box" style="border-left-color: #6366f1;">
            @if (item.note || item.notes || item.description) {
            <div class="mb-1">{{ item.note || item.notes || item.description }}</div>
            }
            @if (item.targetStatus) {
            <div>
              Target Status: <strong>{{ item.targetStatus }}</strong>
            </div>
            }
            @if (item.projectTab || item.source) {
            <div [class.mt-1]="item.targetStatus" style="font-size: 12px; color: #64748b;">
              Source : <strong style="color: #334155;">{{ item.projectTab || item.source }}</strong>
            </div>
            }
          </div>
          }

          <!-- Creator Info -->
          @if (item.createdBy?.userName) {
          <div class="d-flex align-items-center mb-2" style="gap: 6px; font-size: 11.5px; color: #64748b;">
            @if (item.createdBy?.profileImg) {
            <img [src]="item.createdBy.profileImg" class="rounded-circle" width="16" height="16"
              style="object-fit: cover;" (error)="item.createdBy.profileImg = null" />
            } @else {
            <i class="fas fa-user-circle" style="font-size: 12px; color: #94a3b8;"></i>
            }
            <span>Created by <strong>{{ item.createdBy.userName }}</strong></span>
          </div>
          }

          <!-- Card Footer: Due Date + Time + Project Pill + Action -->
          <div class="reminder-card-footer">
            <div class="reminder-due-time">
              <div class="d-flex align-items-center" style="gap: 5px;">
                <i class="far fa-calendar-alt"></i>
                <span>{{ (item.dueAt || item.reminderDate || item.date || item.createdAt) | date:'dd MMM yyyy' }}</span>
              </div>
              @if (hasReminderTime(item.dueAt || item.reminderDate || item.date)) {
              <div class="d-flex align-items-center reminder-time-text"
                style="gap: 5px; font-size: 11.5px; color: #64748b; margin-top: 2px;">
                <i class="far fa-clock" style="font-size: 10.5px; color: #6366f1;"></i>
                <span>{{ (item.dueAt || item.reminderDate || item.date) | date:'hh:mm a' }}</span>
              </div>
              }
            </div>

            <div class="d-flex align-items-center" style="gap: 8px;">
              @if (item.project || getLeadProjectBadge(item)) {
              <span class="project-pill-badge" [ngClass]="{
                'badge-iic-lab': (item.project || getLeadProjectBadge(item)) === 'IIC-LAB',
                'badge-iic': (item.project || getLeadProjectBadge(item)) === 'IIC',
                'badge-v-retail': (item.project || getLeadProjectBadge(item)) === 'V-RETAIL',
                'badge-v-estate': (item.project || getLeadProjectBadge(item)) === 'V-ESTATE',
                'badge-outbound': (item.project || getLeadProjectBadge(item)) === 'OUTBOUND'
              }">{{ item.project || getLeadProjectBadge(item) }}</span>
              }

              @if ((item.status || activeReminderTab) !== 'Completed') {
              <button type="button" class="reminder-done-btn"
                [class.btn-ready]="hasUpcomingTaskScheduled(item)"
                [class.btn-needs-task]="!hasUpcomingTaskScheduled(item)"
                [disabled]="updatingReminderId === (item._id || item.id)"
                (click)="markReminderAsDone(item, $event)"
                [title]="hasUpcomingTaskScheduled(item) ? 'Mark reminder as completed' : 'Set reminder for next task to complete'">
                @if (updatingReminderId === (item._id || item.id)) {
                <span class="spinner-border spinner-border-sm mr-1" role="status"
                  style="width: 11px; height: 11px; border-width: 1.5px;"></span>
                } @else {
                <i class="fas fa-check mr-1"></i>
                }
                Mark as Done
              </button>
              } @else {
              <span class="reminder-completed-pill">
                <i class="fas fa-check-circle mr-1"></i> Done
              </span>
              }
            </div>
          </div>
        </div>
        }
      </div>

      <!-- Load More Spinner -->
      @if (remindersLoadingMore) {
      <div class="text-center py-3">
        <span class="spinner-border spinner-border-sm text-primary"></span>
        <span class="ml-2 text-muted" style="font-size: 12px;">Loading more...</span>
      </div>
      }
      <!-- Load More Button -->
      @if (remindersHasMore[activeReminderTab] && !remindersLoadingMore && remindersData[activeReminderTab].length >=
      remindersLimit) {
      <div class="text-center mt-3">
        <button type="button" class="btn btn-sm btn-outline-primary px-3"
          (click)="fetchFollowUpReminders(activeReminderTab, true)"
          style="border-radius: 20px; font-size: 12px; font-weight: 600;">
          Load More
        </button>
      </div>
      }
      }
      <!-- Empty State (Only shown when not loading!) -->
      @else if (!isRemindersLoading) {
      <div class="reminders-empty-state">
        <i class="far fa-bell-slash"></i>
        <p>No {{ activeReminderTab.toLowerCase() }} follow-up reminders</p>
        <span>Reminders scheduled with follow-up tasks and dispositions will appear here.</span>
      </div>
      }
    </div>
  </div>

  <div class="sales-graph-container d-flex mt-5">
    <div class="sales-chart-bg">
      <div class="chart-head">
        <p class="">
          <img class="mr-2" src="../../../assets/leads/leadsByScore.png" alt="" width="38px" />
          <span class="dashboard-chart-title">Territory Map</span>
        </p>
      </div>
      <div #chart class="chart-container mt-4"></div>
    </div>
  </div>

  @if (project !== 'ALL') {
  <div class="sticky-note-container mt-5 d-flex w-100">
    <div class="sticky-note mr-4" [class.editing]="isEditing" [class.saved]="saveAnimation">
      <!-- Spiral Top -->
      <div class="spiral-row">
        <span class="hole"></span>
        <span class="hole"></span>
        <span class="hole"></span>
        <span class="hole"></span>
        <span class="hole"></span>
        <span class="hole"></span>
        <span class="hole"></span>
        <span class="hole"></span>
      </div>

      <div class="border-line"></div>

      <!-- TEXTAREA -->
      <textarea class="sticky-text" rows="8" [placeholder]="!editingNoteId ? 'Write something...' : ''"
        [(ngModel)]="noteText" [attr.readonly]="isEditing ? null : true"></textarea>

      <!-- BUTTONS -->
      <div class="sticky-bottom-actions">
        <button id="editBtn" class="sticky-action-btn edit-btn" [class.active-mode]="isEditing" title="Edit Note"
          (click)="enableEditMode()">
          <svg xmlns="http://www.w3.org/2000/svg" width="1.3rem" height="1.3rem" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83l3.75 3.75z" />
          </svg>
        </button>

        <!-- SAVE BUTTON -->
        <button id="saveBtn" class="sticky-action-btn save-btn" title="Save Note" (click)="saveNote()"
          [disabled]="!isEditing || !isNoteChanged">
          <svg xmlns="http://www.w3.org/2000/svg" width="1.3rem" height="1.3rem" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3s3 1.34 3 3s-1.34 3-3 3m3-10H5V5h10z" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Follow-up Meeting Container -->
    <div class="Follow-up-meeting">
      <div class="follow-up-header-wrapper d-flex align-items-center justify-content-between pb-2 mb-3"
        style="border-bottom: 1px dashed #C0CFEF;">
        <h3 class="follow-up-head d-flex align-items-center mb-0" style="border-bottom: none;">
          <img class="mr-2" src="../../../assets/leads/leadsByScore.png" alt="" width="42px" />Follow - up Meeting
        </h3>

        <ul class="followup-tabs d-flex align-items-center mb-0 list-unstyled" style="gap: 8px;">
          <li [class.active]="activeFollowupTab === 'Incomplete'" (click)="onFollowupTabChange('Incomplete')">
            Upcoming ({{ upcomingCount }})
          </li>
          <li [class.active]="activeFollowupTab === 'Completed'" (click)="onFollowupTabChange('Completed')">
            Completed ({{ completedCount }})
          </li>
        </ul>
      </div>
      <div class="follow-up-banner" (scroll)="onFollowupScroll()">
        @if (isFollowupLoading && (!followup || followup.length === 0)) {
        <div class="text-center py-5 d-flex flex-column align-items-center justify-content-center h-100">
          <div class="spinner-border text-primary mb-3" role="status" style="width: 2.5rem; height: 2.5rem;">
            <span class="sr-only">Loading...</span>
          </div>
          <p class="text-muted mb-0 font-weight-500" style="font-size: 14px;">
            Loading {{ activeFollowupTab === 'Incomplete' ? 'upcoming' : 'completed' }} meetings...
          </p>
        </div>
        } @else if (followup && followup.length > 0) {
        @for (item of followup; track item._id) {
        <div class="upcoming-listing d-flex justify-content-between align-items-center mb-3">
          <div class="d-flex align-items-center">
            <img [src]="item?.companyProfileImg || '../../../assets/leads/leadsByScore.png'" width="50" height="50"
              alt="company-logo" class="comp-img" />
            <div class="d-block comp-name ml-3">
              <p class="mb-0 font-weight-bold">{{ item?.companyName || item?.name || '-' }}</p>
              <span>{{ item?.type || '-' }}</span>
            </div>
          </div>

          <div class="time-txt text-center">
            <p class="mb-0 font-weight-bold">{{ item?.time || formatTimeTo12Hour(item?.time) || '-' }}</p>
            @if (item?.date) {
            <span class="text-muted" style="font-size: 12px;">{{ item?.date | date: 'dd MMM yyyy' }}</span>
            }
          </div>

          <div class="btn-wrapper d-flex align-items-center">
            @if (activeFollowupTab === 'Incomplete') {
            <button class="pill-btn remove" (click)="onUpdateFollowUp(item, 'Removed')">Remove</button>
            <button class="pill-btn done" (click)="onUpdateFollowUp(item, 'Completed')">Done</button>
            } @else {
            <span class="badge badge-success px-3 py-2" style="font-size: 14px; border-radius: 20px;">Completed</span>
            }
          </div>
        </div>
        }
        @if (followupLoadingMore) {
        <div class="text-center py-2">
          <span class="spinner-border spinner-border-sm text-primary"></span>
        </div>
        }
        } @else if (!isFollowupLoading) {
        <div class="text-center py-4 d-flex flex-column align-items-center justify-content-center h-100">
          @if (activeFollowupTab === 'Incomplete') {
          <img src="../../../assets/leads/no-upcoming-meeting.png" alt="No upcoming meetings"
            style="max-width: 280px; width: 100%; height: auto;" />
          } @else {
          <img src="../../../assets/leads/no-completed.png" alt="No completed meetings"
            style="max-width: 280px; width: 100%; height: auto;" />
          }
        </div>
        }
      </div>
    </div>
  </div>
  }

  <div class="leads-listing-banner position-relative">
    <div class="d-flex align-items-center justify-content-between table-header-flex-wrapper">
      <div class="d-flex align-items-center menu-content-inner">
        <div class="leads-count">
          <p>
            Leads

            <span class="count-num ml-1">({{ this.totalAssignedCount }})</span>
          </p>
        </div>

        <div class="search-box ml-3 position-relative">
          <input type="text" placeholder="Search Leads" [(ngModel)]="searchText" (input)="onSearchChange()" />
          <svg class="search-icon position-absolute" width="19" height="19" viewBox="0 0 19 19" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14.3233 12.9048C15.5703 11.2971 16.158 9.27482 15.9668 7.24925C15.7757 5.22367 14.82 3.34701 13.2943 2.00104C11.7685 0.655069 9.78735 -0.0590965 7.75375 0.00383158C5.72015 0.0667597 3.7869 0.902055 2.34731 2.33978C0.906468 3.77851 0.068442 5.7125 0.00401015 7.74765C-0.0604217 9.78279 0.65359 11.7659 2.00054 13.2929C3.34749 14.8199 5.22601 15.7758 7.25329 15.9659C9.28056 16.1559 11.304 15.5658 12.9113 14.3158L12.9543 14.3608L17.1963 18.6038C17.2892 18.6967 17.3995 18.7704 17.5209 18.8207C17.6423 18.871 17.7724 18.8968 17.9038 18.8968C18.0352 18.8968 18.1653 18.871 18.2867 18.8207C18.4081 18.7704 18.5184 18.6967 18.6113 18.6038C18.7042 18.5109 18.7779 18.4006 18.8282 18.2792C18.8785 18.1578 18.9044 18.0277 18.9044 17.8963C18.9044 17.7649 18.8785 17.6348 18.8282 17.5134C18.7779 17.392 18.7042 17.2817 18.6113 17.1888L14.3683 12.9468L14.3233 12.9048ZM12.2473 3.75478C12.8119 4.31026 13.2609 4.97203 13.5685 5.70192C13.8761 6.43181 14.0361 7.21537 14.0393 8.0074C14.0425 8.79944 13.8889 9.58428 13.5873 10.3166C13.2857 11.049 12.8421 11.7144 12.282 12.2745C11.7219 12.8345 11.0565 13.2782 10.3242 13.5798C9.59181 13.8814 8.80697 14.035 8.01493 14.0318C7.2229 14.0286 6.43933 13.8686 5.70945 13.561C4.97956 13.2534 4.31779 12.8044 3.76231 12.2398C2.65223 11.1115 2.03297 9.59023 2.03941 8.0074C2.04586 6.42458 2.67749 4.90843 3.79672 3.78919C4.91596 2.66996 6.43211 2.03833 8.01493 2.03188C9.59775 2.02544 11.119 2.6447 12.2473 3.75478Z"
              fill="#999999" />
          </svg>

          @if(searchText){
          <img class="search-close" style="cursor: pointer" src="../../../assets/closeIcon.png" alt=""
            (click)="clearSearch()" />
          }
        </div>
      </div>

      @if (project !== 'ALL' && project !== 'all' && project !== 'V-RETAIL' && project !== 'v-retail' && project !==
      'V-ESTATE' && project !== 'v-estate' && project !== 'IIC-LAB' && project !== 'iic-lab') {
      <div class="d-flex align-items-center header-action-btns">
        <button type="button" class="gradient-btn d-inline-flex align-items-center gap-1" style="cursor: pointer;"
          (click)="openCreateOutboundLeadModal()">
          + Create Lead
        </button>
      </div>
      }
    </div>

    <div class="mt-4">
      @if(isSpinnerLoader){
      <div class="loader-wrapper">
        <span class="loader"></span>
      </div>
      }
      <div class="demo-tracker-banner" infiniteScroll #infiniteScroller [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50" (scrolled)="onScroll()" [scrollWindow]="false" [style.height]="bannerHeight"
        [style.maxHeight]="bannerHeight">
        <div class="lead-grid">
          @for(lead of assignedLeads; track lead){

          <div class="lead-card position-relative">
            <div class="bg-square"></div>
            <div class="bg-curves"></div>

            <div class="lead-header d-flex align-items-center justify-content-between">
              <div class="lead-avatar d-flex align-items-center">
                <img class="comp-img" [src]="
                    lead.companyProfileImg
                      ? lead.companyProfileImg
                      : '/assets/leads/default-icon.png'
                  " />
                <div class="lead-title ml-2">
                  <h3 [attr.title]="lead.name">{{ lead.name }}</h3>
                  @if (lead.assignedTo?.length > 0) {
                  <p [attr.title]="lead.assignedTo[0].assigneeName">
                    {{ lead.assignedTo[0].assigneeName }}
                    <span>( Manager )</span>
                  </p>
                  }
                </div>
              </div>

              @if (lead.customerValue || lead.badge) {
              <div class="badge-pill {{ getBadgeClass(lead?.customerValue || lead?.badge) }}">
                {{ lead.customerValue || lead.badge }}
              </div>
              }
            </div>

            <hr class="line" />

            <div class="lead-info mt-2 mb-1 d-flex">
              <div class="w-100">
                <div class="info-row">
                  <img src="/assets/leads/email-icon.png" width="16" height="12" alt="" />
                  <div>
                    <label class="mb-0" for="email">Email</label>
                    <p class="mb-0">{{ getLeadEmail(lead) }}</p>
                  </div>
                </div>

                <div class="info-row justify-content-between align-items-center">
                  <div class="d-flex align-items-center" style="gap: 8px">
                    <img src="/assets/leads/phone-icon.png" width="16" height="16" alt="" />
                    <div>
                      <label class="mb-0" for="email">Phone</label>
                      <p class="mb-0">{{ getLeadPhone(lead) }}</p>
                    </div>
                  </div>

                  @if (lead.status) {
                  <div title="{{ lead.status }}" class="status-tag in-progress">
                    {{ lead.status }}
                  </div>
                  }
                  @if (lead.deal) {
                  <div class="status-tag deal-tag" [class.lost]="lead.deal.status === 'cancelled'" [class.won]="lead.deal.status !== 'pipeline' && lead.deal.status !== 'cancelled'" title="Deal in Finance: {{ lead.deal.name }} · {{ lead.deal.status }}">
                    {{ lead.deal.status === 'pipeline' ? 'Pipeline deal' : (lead.deal.status === 'cancelled' ? 'Deal lost' : 'Deal won') }}
                  </div>
                  }
                </div>

                <div class="info-row">
                  <img src="/assets/leads/company-icon.png" width="16" height="16" alt="" />
                  <div>
                    <label class="mb-0" for="email">Company</label>
                    <p class="mb-0">
                      {{ lead.companyName ? lead.companyName : "-" }}
                    </p>
                  </div>
                </div>

                <div class="info-row">
                  <img class="assigned-img" [src]="getAssignedByImg(lead)"
                    (error)="onImgError($event, '/assets/leads/user-icon.png')" width="20" height="20"
                    alt="Assigned By" />
                  <div>
                    <label class="mb-0" for="email">Assigned By</label>
                    <p class="mb-0">{{ getAssignedByName(lead) }}</p>
                  </div>
                </div>
                <div class="info-row align-items-center mb-0">
                  <div class="d-flex align-items-center" style="gap: 10px">
                    <div>
                      <img class="" src="/assets/leads/calendar-icon.png" width="18" />
                    </div>
                    <div class="">
                      <label class="mb-0" for="email">Assigned On</label>
                      <p class="mb-0">
                        {{ getAssignedOnDate(lead?.assignedTo?.assignedOn) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="lead-footer">
              <button class="arrow-btn" (click)="goToKanban()">
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.67969 0L15.3613 7.68164L7.67969 15.3633L6.33203 14.0156L11.6777 8.625H-0.00195312V6.73828H11.6777L6.33203 1.34766L7.67969 0Z"
                    fill="#0D0D0D" />
                </svg>
              </button>
            </div>
          </div>

          } @if(assignedLeads.length === 0){
          <div class="no-leads-found">
            <img src="/assets/leads/no-leads-found.png" width="200" height="200" alt="" />
            <p>No Leads Found!</p>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
} } @case ('kanban') {
<div class="lead-canvas-wrapper">
  <!-- HEADER -->
  <div class="canvas-header d-flex justify-content-between align-items-center">
    <div class="canvas-header-left d-flex align-items-center">
      @if (projectIcons[project]) {
      <div class="project-logo-container">
        <img class="project-logo" [src]="projectIcons[project]" alt="Logo" />
      </div>
      } @else {
      <div class="canvas-header-icon-box">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      </div>
      }
      <div class="canvas-title-block">
        <h3 class="canvas-title">{{ canvasTitle }}</h3>
        <p class="canvas-subtitle">
          See Your Latest Updates Of Your <span>Leads</span>
        </p>
      </div>
    </div>

    <div class="canvas-header-right d-flex align-items-center">
      @if (project !== 'ALL' && project !== 'all' && project !== 'V-RETAIL' && project !== 'v-retail' && project !==
      'V-ESTATE' && project !== 'v-estate' && project !== 'IIC-LAB' && project !== 'iic-lab') {
      <button type="button" class="gradient-btn d-inline-flex align-items-center gap-1 mr-2"
        style="cursor: pointer; height: 38px; padding: 0 16px; font-size: 14px;"
        (click)="openCreateOutboundLeadModal()">
        + Create Lead
      </button>
      }

      <div class="search-box kanban-search position-relative">
        <input type="text" placeholder="Search Assigned Leads" [(ngModel)]="kanbanSearchQuery"
          (input)="onKanbanSearchChange()" />
        <svg class="search-icon position-absolute" width="18" height="18" viewBox="0 0 19 19" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M14.3233 12.9048C15.5703 11.2971 16.158 9.27482 15.9668 7.24925C15.7757 5.22367 14.82 3.34701 13.2943 2.00104C11.7685 0.655069 9.78735 -0.0590965 7.75375 0.00383158C5.72015 0.0667597 3.7869 0.902055 2.34731 2.33978C0.906468 3.77851 0.068442 5.7125 0.00401015 7.74765C-0.0604217 9.78279 0.65359 11.7659 2.00054 13.2929C3.34749 14.8199 5.22601 15.7758 7.25329 15.9659C9.28056 16.1559 11.304 15.5658 12.9113 14.3158L12.9543 14.3608L17.1963 18.6038C17.2892 18.6967 17.3995 18.7704 17.5209 18.8207C17.6423 18.871 17.7724 18.8968 17.9038 18.8968C18.0352 18.8968 18.1653 18.871 18.2867 18.8207C18.4081 18.7704 18.5184 18.6967 18.6113 18.6038C18.7042 18.5109 18.7779 18.4006 18.8282 18.2792C18.8785 18.1578 18.9044 18.0277 18.9044 17.8963C18.9044 17.7649 18.8785 17.6348 18.8282 17.5134C18.7779 17.392 18.7042 17.2817 18.6113 17.1888L14.3683 12.9468L14.3233 12.9048ZM12.2473 3.75478C12.8119 4.31026 13.2609 4.97203 13.5685 5.70192C13.8761 6.43181 14.0361 7.21537 14.0393 8.0074C14.0425 8.79944 13.8889 9.58428 13.5873 10.3166C13.2857 11.049 12.8421 11.7144 12.282 12.2745C11.7219 12.8345 11.0565 13.2782 10.3242 13.5798C9.59181 13.8814 8.80697 14.035 8.01493 14.0318C7.2229 14.0286 6.43933 13.8686 5.70945 13.561C4.97956 13.2534 4.31779 12.8044 3.76231 12.2398C2.65223 11.1115 2.03297 9.59023 2.03941 8.0074C2.04586 6.42458 2.67749 4.90843 3.79672 3.78919C4.91596 2.66996 6.43211 2.03833 8.01493 2.03188C9.59775 2.02544 11.119 2.6447 12.2473 3.75478Z"
            fill="#999999" />
        </svg>
        @if(kanbanSearchQuery){
        <img class="search-close" style="cursor: pointer" src="../../../assets/closeIcon.png" alt="Clear search"
          (click)="clearKanbanSearch()" />
        }
      </div>

      <div class="dropdown customervalue-dropdown">
        <button class="btn btn-outline-primary dropdown-toggle d-flex align-items-center" type="button"
          (click)="toggleCustomerValueDropdown($event)">
          <span>{{ customerValueFilterLabel }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
            style="flex-shrink: 0; margin-left: 4px;">
            <path fill="currentColor" d="m12 15l5-5H7z" />
          </svg>
        </button>

        <ul class="dropdown-menu dropdown-menu-end" [class.show]="isCustomerValueDropdownOpen">
          <li>
            <a class="dropdown-item" [class.active]="selectedCustomerValue === ''"
              (click)="applyCustomerValueFilter('')">
              All Badges
            </a>
          </li>
          <li>
            <a class="dropdown-item" [class.active]="selectedCustomerValue === 'Premium'"
              (click)="applyCustomerValueFilter('Premium')">
              Premium
            </a>
          </li>
          <li>
            <a class="dropdown-item" [class.active]="selectedCustomerValue === 'Emerging'"
              (click)="applyCustomerValueFilter('Emerging')">
              Emerging
            </a>
          </li>
          <li>
            <a class="dropdown-item" [class.active]="selectedCustomerValue === 'Basic'"
              (click)="applyCustomerValueFilter('Basic')">
              Basic
            </a>
          </li>
          <li>
            <a class="dropdown-item" [class.active]="selectedCustomerValue === 'Regular'"
              (click)="applyCustomerValueFilter('Regular')">
              Regular
            </a>
          </li>
        </ul>
      </div>

      <button class="btn-back d-flex align-items-center" (click)="toggleSortOrder()">

        @if(sortOrder === -1){
        <span><svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M12 4a1 1 0 0 1 1 1v11.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L11 16.586V5a1 1 0 0 1 1-1" />
          </svg>Sort by Oldest</span>
        } @if(sortOrder === 1){
        <span><svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M5.23 10.64a1 1 0 0 0 1.41.13L11 7.14V19a1 1 0 0 0 2 0V7.14l4.36 3.63a1 1 0 1 0 1.28-1.54l-6-5l-.15-.09l-.13-.07a1 1 0 0 0-.72 0l-.13.07l-.15.09l-6 5a1 1 0 0 0-.13 1.41" />
          </svg> Sort by Newest</span>
        }
      </button>


      <button class="btn-back d-flex align-items-center" (click)="goBackToLeads()">
        <span class="btn-back-icon">
          <span class="dot"></span><span class="dot"></span>
          <span class="dot"></span><span class="dot"></span>
        </span>
        <span>Dashboard</span>
      </button>

    </div>
  </div>

  <hr class="canvas-divider" />

  <!-- MAIN SCROLL WRAPPER-->
  <div class="canvas-scroll-container" cdkScrollable #scrollContainer (scroll)="onCanvasScroll($event)">
    <!-- TABS -->
    <div class="canvas-tabs d-flex">
      @for (tab of canvasTabs; track tab.id; let i = $index) {
      <div class="canvas-tab" (click)="scrollToColumn(i)">
        <img [ngClass]="{ 'lost-img': tab.isDanger, 'closing-pool-img': tab.isClosingPool }" [src]="tab.icon"
          width="42" />

        <p class="mb-0" [ngClass]="{
    'lost-text': tab.isDanger,
    'unqualified-text': tab.isUnqualified,
    'success-text': tab.isSuccess,
    'progress-text': tab.isProgress,
    'not-started-text': tab.notStarted,
    'closing-pool-text': tab.isClosingPool
  }">
          {{ tab.label }} ({{ totalStatusCount[tab.status] || 0 }})
        </p>
      </div>
      }
    </div>


    <!-- COLUMN WRAPPER -->
    <div class="canvas-columns" cdkDropListGroup>
      <!-- FOLLOW-UP TASK COLUMN (BEFORE NOT STARTED) -->
      <div class="canvas-column sticky-column" id="follow-up-task-list" cdkDropList
        [cdkDropListData]="followUpLeadsCanvas" [cdkDropListEnterPredicate]="neverEnterPredicate" infiniteScroll
        [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100"
        (scrolled)="onKanbanScroll('Follow-up Task')">
        @if (isCanvasLoading && !isSavingLead) {
        <div class="w-100 shimmer-wrapper">
          @for (i of [1,2,3,4,5]; track i) {
          <div class="assigned-card shimmer-card mb-3">
            <div class="shimmer-line w-50"></div>
            <div class="shimmer-line w-75 mt-4"></div>
            <div class="shimmer-line w-60 mt-4"></div>
            <div class="shimmer-line w-40 mt-4"></div>
          </div>
          }
        </div>
        }
        @for (lead of followUpLeadsCanvas; track lead._id) {
        <div class="assigned-card mb-2" cdkDrag [cdkDragData]="lead" [cdkDragDisabled]="true"
          [cdkDragStartDelay]="dragStartDelay">
          <!-- CARD HEADER & CLICK TO OPEN DETAIL PANEL -->
          <div (click)="openDetailsPanel(lead); selectLeadInCanvas(lead)">
            <div class="card-header-top mb-2">
              <div>
                @if(lead?.project || project || isOutboundLead(lead)){
                <span class="project-pill-badge" [ngClass]="{
                  'badge-iic-lab': getLeadProjectBadge(lead) === 'IIC-LAB',
                  'badge-v-retail': getLeadProjectBadge(lead) === 'V-RETAIL',
                  'badge-v-estate': getLeadProjectBadge(lead) === 'V-ESTATE',
                  'badge-outbound': getLeadProjectBadge(lead) === 'OUTBOUND'
                }">{{ getLeadProjectBadge(lead) }}</span>
                }
              </div>

              <div class="d-flex align-items-center">
                @if(lead?.hasClosingPotential){
                <span class="closing-pool-badge-pill mr-1" title="In Closing Pool">🦄</span>
                }
                @if(lead?.customerValue || lead?.badge){
                <div class="badge-pill {{ getBadgeClass(lead?.customerValue || lead?.badge) }}">
                  {{ lead.customerValue || lead.badge }}
                </div>
                }
                <button type="button" class="btn btn-accordion-toggle ml-2" (click)="toggleAccordion(lead, $event)">
                  <svg width="14" height="8" viewBox="0 0 14 8" [class.rotate-180]="expandedLeadId === lead._id">
                    <path d="M1 1L7 7L13 1" stroke="#425166" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- LEAD IDENTITY (AVATAR + NAME) -->
            <div class="card-lead-identity mb-2">
              <div class="lead-avatar-box">
                <img [src]="lead?.companyProfileImg || '/assets/leads/default-icon.png'" alt="Avatar" />
              </div>
              <div class="lead-name-box">
                @if (lead?.companyName && lead?.companyName !== '-' && lead?.companyName !== lead?.name) {
                <p class="lead-company-name mb-0">{{ lead?.companyName }}</p>
                }
                <h5 class="lead-person-name mb-0">{{ lead?.name || lead?.companyName || "-" }}</h5>
              </div>
            </div>

            <!-- SUMMARY MIDDLE CARD (VISIBLE WHEN COLLAPSED) -->
            @if (expandedLeadId !== lead._id) {
            <div class="card-summary-box mb-1">
              <div class="summary-assignee-col">
                <img class="assignee-avatar"
                  [src]="lead?.assignedTo?.assignedByImg || lead?.assignedTo?.userProfileImg || '/assets/leads/user-icon.png'"
                  (error)="onImgError($event, '/assets/leads/user-icon.png')" alt="Assignee" />
                <div class="assignee-text-group">
                  <span class="summary-label">Assigned To</span>
                  <p class="summary-assignee-name" [innerHTML]="getAssignedToDisplay(lead, true)"></p>
                </div>
              </div>

              <div class="summary-divider"></div>

              <div class="summary-meta-col">
                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Assigned On</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.assignedTo?.assignedOn) }}</p>
                  </div>
                </div>

                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Last Activity</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.updatedAt) }}</p>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>

      <div class="canvas-column sticky-column" id="assigned-list" cdkDropList [cdkDropListData]="assignedLeadsCanvas"
        infiniteScroll #infiniteScroller [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        (scrolled)="onKanbanScroll('Not started')" [scrollWindow]="false"
        [cdkDropListEnterPredicate]="alwaysEnterPredicate" (cdkDropListDropped)="onDrop($event, 'Not started')">
        @if (isCanvasLoading && !isSavingLead) {
        <div class="w-100 shimmer-wrapper">
          @for (i of [1,2,3,4,5]; track i) {
          <div class="assigned-card shimmer-card mb-3">
            <div class="shimmer-line w-50"></div>

            <div class="shimmer-line w-75 mt-4"></div>

            <div class="shimmer-line w-60 mt-4"></div>

            <div class="shimmer-line w-40 mt-4"></div>
          </div>
          }
        </div>
        }
        @for (lead of assignedLeadsCanvas; track lead._id) {
        <div class="assigned-card mb-2" cdkDrag [cdkDragData]="lead" [cdkDragStartDelay]="dragStartDelay">
          <!-- CARD HEADER & CLICK TO OPEN DETAIL PANEL -->
          <div (click)="openDetailsPanel(lead); selectLeadInCanvas(lead)">
            <div class="card-header-top mb-2">
              <div>
                @if(lead?.project || project || isOutboundLead(lead)){
                <span class="project-pill-badge" [ngClass]="{
                  'badge-iic-lab': getLeadProjectBadge(lead) === 'IIC-LAB',
                  'badge-v-retail': getLeadProjectBadge(lead) === 'V-RETAIL',
                  'badge-v-estate': getLeadProjectBadge(lead) === 'V-ESTATE',
                  'badge-outbound': getLeadProjectBadge(lead) === 'OUTBOUND'
                }">{{ getLeadProjectBadge(lead) }}</span>
                }
              </div>

              <div class="d-flex align-items-center">
                @if(lead?.hasClosingPotential){
                <span class="closing-pool-badge-pill mr-1" title="In Closing Pool">🦄</span>
                }
                @if(lead?.customerValue || lead?.badge){
                <div class="badge-pill {{ getBadgeClass(lead?.customerValue || lead?.badge) }}">
                  {{ lead.customerValue || lead.badge }}
                </div>
                }
                <button type="button" class="btn btn-accordion-toggle ml-2" (click)="toggleAccordion(lead, $event)">
                  <svg width="14" height="8" viewBox="0 0 14 8" [class.rotate-180]="expandedLeadId === lead._id">
                    <path d="M1 1L7 7L13 1" stroke="#425166" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- LEAD IDENTITY (AVATAR + NAME) -->
            <div class="card-lead-identity mb-2">
              <div class="lead-avatar-box">
                <img [src]="lead?.companyProfileImg || '/assets/leads/default-icon.png'" alt="Avatar" />
              </div>
              <div class="lead-name-box">
                @if (lead?.companyName && lead?.companyName !== '-' && lead?.companyName !== lead?.name) {
                <p class="lead-company-name mb-0">{{ lead?.companyName }}</p>
                }
                <h5 class="lead-person-name mb-0">{{ lead?.name || lead?.companyName || "-" }}</h5>
              </div>
            </div>

            <!-- SUMMARY MIDDLE CARD (VISIBLE WHEN COLLAPSED) -->
            @if (expandedLeadId !== lead._id) {
            <div class="card-summary-box mb-1">
              <div class="summary-assignee-col">
                <img class="assignee-avatar"
                  [src]="lead?.assignedTo?.assignedByImg || lead?.assignedTo?.userProfileImg || '/assets/leads/user-icon.png'"
                  (error)="onImgError($event, '/assets/leads/user-icon.png')" alt="Assignee" />
                <div class="assignee-text-group">
                  <span class="summary-label">Assigned To</span>
                  <p class="summary-assignee-name" [innerHTML]="getAssignedToDisplay(lead, true)"></p>
                </div>
              </div>

              <div class="summary-divider"></div>

              <div class="summary-meta-col">
                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Assigned On</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.assignedTo?.assignedOn) }}</p>
                  </div>
                </div>

                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Last Activity</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.updatedAt) }}</p>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>

          <!-- ACCORDION EXPANDED DETAILS -->
          @if(expandedLeadId === lead._id){
          <div class="card-expanded-section mt-3 pt-2" (click)="openDetailsPanel(lead); selectLeadInCanvas(lead)">

            <!-- Section 1: Basic Information -->
            <div class="section-divider-header">
              <div class="section-header-left">
                <div class="section-icon-badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <span class="section-title-text">Basic Information</span>
              </div>
              <div class="section-header-line"></div>
            </div>

            <div class="basic-info-grid mb-3">
              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Name</span>
                  <p class="field-value">{{ lead?.name || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Job Role</span>
                  <p class="field-value">{{ lead?.designation || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Created</span>
                  <p class="field-value mb-0">{{ lead?.createdAt | date : "MMMM d, yyyy" }}</p>
                  @if (lead?.createdAt) {
                  <div class="text-muted small" style="font-size: 11px; margin-top: 1px; font-weight: 400;">
                    ({{ lead?.createdAt | date : "hh:mm a" }})
                  </div>
                  }
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                    </path>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Next Follow Up</span>
                  <p class="field-value">{{ lead?.followUpDate ? (lead.followUpDate | date : "MMMM d, yyyy") : '-' }}
                  </p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Email</span>
                  <p class="field-value text-truncate">{{ getLeadEmail(lead) || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                    </path>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Phone</span>
                  <p class="field-value">{{ getLeadPhone(lead) }}</p>
                </div>
              </div>
            </div>

            <!-- Section 2: Assignment Details -->
            <div class="section-divider-header">
              <div class="section-header-left">
                <div class="section-icon-badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                  </svg>
                </div>
                <span class="section-title-text">Assignment Details</span>
              </div>
              <div class="section-header-line"></div>
            </div>

            <div class="card-summary-box expanded-assignment-box mt-2">
              <div class="summary-assignee-col">
                <img class="assignee-avatar"
                  [src]="lead?.assignedTo?.assignedByImg || lead?.assignedTo?.userProfileImg || '/assets/leads/user-icon.png'"
                  alt="Assignee" />
                <div class="assignee-text-group">
                  <span class="summary-label">Assigned To</span>
                  <p class="summary-assignee-name" [innerHTML]="getAssignedToDisplay(lead, true)"></p>
                </div>
              </div>

              <div class="summary-divider"></div>

              <div class="summary-meta-col">
                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Assigned On</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.assignedTo?.assignedOn) }}</p>
                  </div>
                </div>

                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Last Activity</span>
                    <p class="summary-value">{{ getAssignedOnDate(lead?.updatedAt) }}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
          }
        </div>


        }

      </div>

      @for (col of emptyColumns; track col.index) {
      <div class="canvas-column" id="drop-list-{{ col.index }}" cdkDropList [cdkDropListData]="col.items"
        [cdkDropListEnterPredicate]="(col.status === 'Follow-up Task' || col.status === 'Closing Pool') ? neverEnterPredicate : alwaysEnterPredicate"
        (cdkDropListDropped)="onDrop($event, col.status)" infiniteScroll [scrollWindow]="false"
        [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100" (scrolled)="onKanbanScroll(col.status)">
        @if (isCanvasLoading && !isSavingLead) {
        <div class="w-100 shimmer-wrapper">
          @for (i of [1,2,3,4,5]; track i) {
          <div class="assigned-card shimmer-card mb-3">
            <div class="shimmer-line w-50"></div>

            <div class="shimmer-line w-75 mt-4"></div>

            <div class="shimmer-line w-60 mt-4"></div>

            <div class="shimmer-line w-40 mt-4"></div>
          </div>
          }
        </div>
        } @for (item of col.items; track item._id) {
        <div class="assigned-card mb-2" cdkDrag [cdkDragData]="item"
          [cdkDragDisabled]="col.status === 'Follow-up Task' || col.status === 'Closing Pool'"
          [cdkDragStartDelay]="dragStartDelay">
          <!-- CARD HEADER & CLICK TO OPEN DETAIL PANEL -->
          <div (click)="openDetailsPanel(item); selectLeadInCanvas(item)">
            <div class="card-header-top mb-2">
              <div>
                @if(item?.project || project || isOutboundLead(item)){
                <span class="project-pill-badge" [ngClass]="{
                  'badge-iic-lab': getLeadProjectBadge(item) === 'IIC-LAB',
                  'badge-v-retail': getLeadProjectBadge(item) === 'V-RETAIL',
                  'badge-v-estate': getLeadProjectBadge(item) === 'V-ESTATE',
                  'badge-outbound': getLeadProjectBadge(item) === 'OUTBOUND'
                }">{{ getLeadProjectBadge(item) }}</span>
                }
              </div>

              <div class="d-flex align-items-center">
                @if(item?.hasClosingPotential){
                <span class="closing-pool-badge-pill mr-1" title="In Closing Pool">🦄</span>
                }
                @if(item?.customerValue || item?.badge){
                <div class="badge-pill {{ getBadgeClass(item?.customerValue || item?.badge) }}">
                  {{ item.customerValue || item.badge }}
                </div>
                }
                <button type="button" class="btn btn-accordion-toggle ml-2" (click)="toggleAccordion(item, $event)">
                  <svg width="14" height="8" viewBox="0 0 14 8" [class.rotate-180]="expandedLeadId === item._id">
                    <path d="M1 1L7 7L13 1" stroke="#425166" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- LEAD IDENTITY (AVATAR + NAME) -->
            <div class="card-lead-identity mb-2">
              <div class="lead-avatar-box">
                <img [src]="item?.companyProfileImg || '/assets/leads/default-icon.png'" alt="Avatar" />
              </div>
              <div class="lead-name-box">
                @if (item?.companyName && item?.companyName !== '-' && item?.companyName !== item?.name) {
                <p class="lead-company-name mb-0">{{ item?.companyName }}</p>
                }
                <h5 class="lead-person-name mb-0">{{ item?.contactName || item?.name || item?.companyName || "-" }}</h5>
              </div>
            </div>

            <!-- SUMMARY MIDDLE CARD (VISIBLE WHEN COLLAPSED) -->
            @if (expandedLeadId !== item._id) {
            <div class="card-summary-box mb-1">
              <div class="summary-assignee-col">
                <img class="assignee-avatar"
                  [src]="item?.assignedTo?.assignedByImg || item?.assignedTo?.userProfileImg || '/assets/leads/user-icon.png'"
                  alt="Assignee" />
                <div class="assignee-text-group">
                  <span class="summary-label">Assigned To</span>
                  <p class="summary-assignee-name" [innerHTML]="getAssignedToDisplay(item, true)"></p>
                </div>
              </div>

              <div class="summary-divider"></div>

              <div class="summary-meta-col">
                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Assigned On</span>
                    <p class="summary-value">{{ getAssignedOnDate(item?.assignedTo?.assignedOn) }}</p>
                  </div>
                </div>

                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Last Activity</span>
                    <p class="summary-value">{{ getAssignedOnDate(item?.updatedAt) }}</p>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>

          <!-- ACCORDION EXPANDED DETAILS -->
          @if(expandedLeadId === item._id){
          <div class="card-expanded-section mt-3 pt-2" (click)="openDetailsPanel(item); selectLeadInCanvas(item)">

            <!-- Section 1: Basic Information -->
            <div class="section-divider-header">
              <div class="section-header-left">
                <div class="section-icon-badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <span class="section-title-text">Basic Information</span>
              </div>
              <div class="section-header-line"></div>
            </div>

            <div class="basic-info-grid mb-3">
              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Name</span>
                  <p class="field-value">{{ item?.contactName || item?.name || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Job Role</span>
                  <p class="field-value">{{ item?.designation || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Created</span>
                  <p class="field-value mb-0">{{ item?.createdAt | date : "MMMM d, yyyy" }}</p>
                  @if (item?.createdAt) {
                  <div class="text-muted small" style="font-size: 11px; margin-top: 1px; font-weight: 400;">
                    ({{ item?.createdAt | date : "hh:mm a" }})
                  </div>
                  }
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                    </path>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Next Follow Up</span>
                  <p class="field-value">{{ item?.followUpDate ? (item.followUpDate | date : "MMMM d, yyyy") : '-' }}
                  </p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Email</span>
                  <p class="field-value text-truncate">{{ getLeadEmail(item) || '-' }}</p>
                </div>
              </div>

              <div class="grid-field-item">
                <div class="field-icon-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                    </path>
                  </svg>
                </div>
                <div class="field-text-block">
                  <span class="field-label">Phone</span>
                  <p class="field-value">{{ getLeadPhone(item) }}</p>
                </div>
              </div>
            </div>

            <!-- Section 2: Assignment Details -->
            <div class="section-divider-header">
              <div class="section-header-left">
                <div class="section-icon-badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                  </svg>
                </div>
                <span class="section-title-text">Assignment Details</span>
              </div>
              <div class="section-header-line"></div>
            </div>

            <div class="card-summary-box expanded-assignment-box mt-2">
              <div class="summary-assignee-col">
                <img class="assignee-avatar"
                  [src]="item?.assignedTo?.assignedByImg || item?.assignedTo?.userProfileImg || '/assets/leads/user-icon.png'"
                  alt="Assignee" />
                <div class="assignee-text-group">
                  <span class="summary-label">Assigned To</span>
                  <p class="summary-assignee-name" [innerHTML]="getAssignedToDisplay(item, true)"></p>
                </div>
              </div>

              <div class="summary-divider"></div>

              <div class="summary-meta-col">
                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Assigned On</span>
                    <p class="summary-value">{{ getAssignedOnDate(item?.assignedTo?.assignedOn) }}</p>
                  </div>
                </div>

                <div class="meta-row">
                  <div class="meta-icon-badge">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.2">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <div class="meta-text-group">
                    <span class="summary-label">Last Activity</span>
                    <p class="summary-value">{{ getAssignedOnDate(item?.updatedAt) }}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
          }
        </div>

        }
      </div>
      }
    </div>
  </div>

  <!-- DETAILS PANEL -->
  @if (showDetailsPanel) {
  <div class="details-panel-backdrop pre-fade" (click)="closeDetailsPanel()">
    <div class="details-panel" (click)="onDetailsPanelClick($event)">
      <form class="lead-update-form" [formGroup]="leadForm" (ngSubmit)="updateLead()">
        <div class="details-header">
          <div class="details-header-left d-flex align-items-center">
            <button type="button" class="details-back-btn" (click)="closeDetailsPanel()">
              <svg xmlns="http://www.w3.org/2000/svg" width="2.2rem" height="2.2rem" viewBox="0 0 24 24">
                <path fill="#000"
                  d="M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42s1.02.39 1.41 0l6.59-6.59a.996.996 0 0 0 0-1.41l-6.58-6.6a.996.996 0 1 0-1.41 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1" />
              </svg>
            </button>
            <div class="canvas-logo d-flex align-items-center" (click)="openUploadLogoModal()">
              <img [src]="logoPreview || 'assets/leads/default-icon.png'" alt="Logo" />
              @if (isLoadingLeadDetails) {
              <span class="spinner-border spinner-border-sm text-primary ml-2"
                title="Refreshing lead details..."></span>
              }
            </div>
          </div>

          <div class="details-header-actions d-flex align-items-center justify-content-end">
            @if (isLeadInClosingPool) {
            <span class="closing-pool-tag-info mr-2">
              <span class="unicorn-icon-text">🦄</span> Closing Pool
            </span>
            }
            <button type="button" class="btn-closing-pool" (click)="toggleClosingPool()"
              [class.in-pool]="isLeadInClosingPool" [disabled]="isUpdatingClosingPool">
              @if (isUpdatingClosingPool) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
              Updating...
              } @else if (isLeadInClosingPool) {
              <span class="unicorn-icon-text">🦄</span> Remove from Closing Pool
              } @else {
              <span class="unicorn-icon-text">🦄</span> Add to Closing Pool
              }
            </button>
            <button class="btn-save" type="submit" [disabled]="
    isUpdatingLead ||
    !hasUnsavedChanges ||
    (!isLeadClosedOrLostOrUnqualified && showReminderSection && (!reminderDueAt || !reminderDueTime || !(selectedReminderStatus || pendingReminderTargetStatus))) ||
    (leadForm.get('phoneNo')?.dirty && leadForm.get('phoneNo')?.invalid) ||
    (shouldCreateFollowUp && followUpForm.invalid)
  " [class.btn-disabled]="
    !hasUnsavedChanges ||
    (!isLeadClosedOrLostOrUnqualified && showReminderSection && (!reminderDueAt || !reminderDueTime || !(selectedReminderStatus || pendingReminderTargetStatus))) ||
    (leadForm.get('phoneNo')?.dirty && leadForm.get('phoneNo')?.invalid) ||
    (shouldCreateFollowUp && followUpForm.invalid)
  ">
              @if (isUpdatingLead) {
              <span class="spinner-border spinner-border-sm mr-2"></span>
              Saving...
              } @else {
              ✓ Save Changes
              }
            </button>
          </div>
        </div>

        <div class="details-body mt-2">
          <div class="detail-row">
            <label>Company Name</label><span class="colon">:</span>
            <div class="d-flex flex-column">
              <input type="text" class="detail-input" formControlName="companyName" />
              @if ( leadForm.get('companyName')?.hasError('maxlength') &&
              (leadForm.get('companyName')?.dirty ||
              leadForm.get('companyName')?.touched) ) {
              <small class="error-text ml-2">
                Maximum 100 characters allowed
              </small>
              }
            </div>
          </div>

          <div class="detail-row">
            <label>Lead name</label><span class="colon">:</span>
            <div class="d-flex flex-column">
              <input type="text" class="detail-input" formControlName="name" />
              @if ( leadForm.get('name')?.hasError('maxlength') &&
              (leadForm.get('name')?.dirty || leadForm.get('name')?.touched) ) {
              <small class="error-text ml-2">
                Maximum 100 characters allowed
              </small>
              }
            </div>
          </div>

          <div class="detail-row">
            <label>Email</label><span class="colon">:</span>
            <div class="d-flex flex-column">
              <input type="text" class="detail-input" formControlName="email" />
            </div>
          </div>

          <div class="detail-row">
            <label>Phone</label><span class="colon">:</span>
            <div class="d-flex flex-column">
              <input type="tel" class="detail-input" formControlName="phoneNo" />
              @if (leadForm.get('phoneNo')?.touched && leadForm.get('phoneNo')?.invalid) {
              <small class="text-danger">
                Enter a valid 10-digit phone number
              </small>
              }

              @if (singleLead?.extractedRecordingUrl || selectedLead?.extractedRecordingUrl ||
              selectedLeadForDetails?.extractedRecordingUrl) {
              <div class="mt-2 w-100">
                <div class="d-flex align-items-center justify-content-between mb-1 px-1">
                  <span class="text-muted" style="font-size: 11.5px; font-weight: 500;margin-left: 8px;">IVR
                    Recording</span>
                  <span class="text-muted" style="font-size: 11.5px; font-weight: 600;">Total Duration: {{
                    formatDuration(audioDuration || singleLead?.duration || selectedLead?.duration ||
                    selectedLeadForDetails?.duration) }}</span>
                </div>
                <div class="custom-audio-player d-flex align-items-center">
                  <button type="button" class="audio-control-btn play-pause-btn"
                    (click)="togglePlayPause(ivrAudioPlayerSales)" [title]="isPlayingAudio ? 'Pause' : 'Play'">
                    @if (isPlayingAudio) {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <rect x="6" y="4" width="4" height="16" rx="1"></rect>
                      <rect x="14" y="4" width="4" height="16" rx="1"></rect>
                    </svg>
                    } @else {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M8 5v14l11-7z"></path>
                    </svg>
                    }
                  </button>

                  <!-- Speed Pill Button RIGHT NEXT to Play button -->
                  <button type="button" class="audio-speed-pill-btn" (click)="toggleAudioSpeed(ivrAudioPlayerSales)"
                    title="Click to cycle speed: 1x -> 1.5x -> 2x -> 3x">
                    {{ selectedAudioSpeed }}x
                  </button>

                  <!-- Time display -->
                  <span class="audio-time-text ml-2 mr-2">
                    {{ formatTime(currentAudioTime) }} / {{ formatTime(audioDuration || singleLead?.duration ||
                    selectedLead?.duration || selectedLeadForDetails?.duration) }}
                  </span>

                  <!-- Seek slider -->
                  <div class="audio-progress-container flex-grow-1 mx-2">
                    <input type="range" class="audio-progress-slider" min="0"
                      [max]="audioDuration || singleLead?.duration || selectedLead?.duration || selectedLeadForDetails?.duration || 100"
                      [value]="currentAudioTime" (input)="onAudioSeekInput($event)"
                      (change)="onAudioSeekChange($event, ivrAudioPlayerSales)" />
                  </div>

                  <!-- Mute toggle button -->
                  <button type="button" class="audio-control-btn mute-btn" (click)="toggleMute(ivrAudioPlayerSales)"
                    [title]="isAudioMuted ? 'Unmute' : 'Mute'">
                    @if (isAudioMuted) {
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                      <line x1="23" y1="9" x2="17" y2="15"></line>
                      <line x1="17" y1="9" x2="23" y2="15"></line>
                    </svg>
                    } @else {
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                      <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                    </svg>
                    }
                  </button>

                  <audio #ivrAudioPlayerSales id="ivrRecordingSales"
                    [src]="singleLead?.extractedRecordingUrl || selectedLead?.extractedRecordingUrl || selectedLeadForDetails?.extractedRecordingUrl"
                    preload="metadata" style="display: none;" (timeupdate)="onAudioTimeUpdate(ivrAudioPlayerSales)"
                    (play)="onAudioPlay($event)" (pause)="isPlayingAudio = false" (ended)="onAudioEnded()"
                    (loadedmetadata)="onAudioLoaded($event)">
                  </audio>
                </div>
              </div>
              } @else if (isIvrLead(singleLead || selectedLead || selectedLeadForDetails)) {
              <div class="mt-2 w-100">
                <div class="d-flex align-items-center justify-content-between mb-1 px-1">
                  <span class="text-muted" style="font-size: 11.5px; font-weight: 500;">IVR Recording</span>
                  @if (singleLead?.duration || selectedLead?.duration || selectedLeadForDetails?.duration) {
                  <span class="text-muted" style="font-size: 11.5px; font-weight: 600;">Total Duration: {{
                    formatDuration(singleLead?.duration || selectedLead?.duration || selectedLeadForDetails?.duration)
                    }}</span>
                  }
                </div>
                <p class="text-muted mb-0 small px-1" style="font-size: 12px;">
                  <i class="fas fa-exclamation-circle mr-1 text-warning"></i>
                  No recording available for this call.
                </p>
              </div>
              }
            </div>
          </div>

          <div class="detail-row">
            <label>Designation</label><span class="colon">:</span>
            <div class="d-flex flex-column">
              <input type="text" class="detail-input" formControlName="designation" />
              @if ( leadForm.get('designation')?.hasError('maxlength') &&
              (leadForm.get('designation')?.dirty ||
              leadForm.get('designation')?.touched) ) {
              <small class="error-text ml-2">
                Maximum 100 characters allowed
              </small>
              }
            </div>
          </div>

          <div class="detail-row">
            <label>Created Date</label><span class="colon">:</span>
            <div class="ml-2">
              <input type="text" class="detail-input created-at-input mb-0"
                [value]="selectedLead?.createdAt ? (selectedLead?.createdAt | date : 'dd MMM yyyy') : '-'" readonly />
              <!-- @if (selectedLead?.createdAt) {
              <div class="text-muted small" style="font-size: 11px; margin-top: 1px; font-weight: 400;">
                ({{ selectedLead?.createdAt | date : 'hh:mm a' }})
              </div>
              } -->
            </div>
          </div>

          <div class="detail-row" [formGroup]="followUpForm">
            <label>Next Follow Up</label>
            <span class="colon">:</span>

            <div class="followup-inline">
              <div class="d-flex align-items-center w-100">
                <!-- Date -->
                <input type="date" class="detail-input" formControlName="date" [min]="todayDate"
                  [class.placeholder]="!followUpForm.value.date" [class.is-invalid]="
                    followUpForm.get('date')?.invalid &&
                    followUpForm.get('date')?.touched
                  " />

                <!-- Time Dropdown -->
                <div class="dropdown custom-dd time-dd" [class.show]="timeDropdownOpen">
                  <button type="button" class="btn dropdown-toggle dd-btn detail-input time-menu"
                    style="width: 141px!important;" (click)="toggleTimeDropdown($event)"
                    [class.placeholder]="!followUpForm.value.time || followUpForm.value.time === 'hh:mm'"
                    [class.is-invalid]="
                      followUpForm.get('time')?.invalid &&
                      followUpForm.get('time')?.touched
                    ">
                    {{ (followUpForm.value.time === 'hh:mm' || !followUpForm.value.time) ? 'Select Time' :
                    followUpForm.value.time }}
                  </button>

                  <div class="dropdown-menu" [class.show]="timeDropdownOpen">
                    @for (t of timeOptions; track $index) {
                    <a class="dropdown-item" (click)="selectTime(t)">
                      {{ t }}
                    </a>
                    }
                  </div>
                </div>
              </div>
              <!-- Type Dropdown -->
              <div class="dropdown custom-dd type-dd mt-3 w-100" [class.show]="typeDropdownOpen">
                <button type="button" class="btn dropdown-toggle dd-btn detail-input w-100"
                  (click)="toggleTypeDropdown($event)" [class.placeholder]="!followUpForm.value.type"
                  [class.is-invalid]="
                    followUpForm.get('type')?.invalid &&
                    followUpForm.get('type')?.touched
                  ">
                  {{ followUpForm.value.type || "Select meeting type" }}
                </button>

                <div class="dropdown-menu ml-2 w-100" [class.show]="typeDropdownOpen">
                  <a class="dropdown-item" (click)="selectType('Virtual')">
                    Virtual
                  </a>
                  <a class="dropdown-item" (click)="selectType('In Person')">
                    In Person
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- FOR ASSISTANT-SALES USER ONLY: Show Reassign -->
          @if (isAssistantSalesUser) {
          <div class="detail-row">
            <label>Reassign</label><span class="colon">:</span>
            <div class="d-flex align-items-center ml-2" style="gap: 8px; flex: 1; max-width: 480px;">
              <!-- Reassign Dropdown (from org-lead/users-list API) -->
              <div class="dropdown custom-dd assignee-dd position-relative" [class.show]="reassignDropdownOpen"
                style="flex: 1;">
                <button type="button"
                  class="btn dropdown-toggle dd-btn w-100 d-flex align-items-center justify-content-between"
                  (click)="toggleReassignDropdown($event)" [class.placeholder]="!selectedReassignUser">
                  <span class="assignee-text text-truncate">
                    {{ selectedReassignUser?.userName || "Select Sales User" }}
                  </span>

                  @if (selectedReassignUser) {
                  <span class="clear-icon" (click)="clearReassignUser($event)" title="Clear selection">
                    ✕
                  </span>
                  }
                </button>

                <div class="dropdown-menu w-100 shadow-sm" [class.show]="reassignDropdownOpen"
                  style="max-height: 220px; overflow-y: auto; padding: 4px; border-radius: 6px; border: 1px solid #e2e8f0; z-index: 1050;">
                  @for (user of salesUsers; track user._id || user.id || $index) {
                  <a class="dropdown-item d-flex align-items-center"
                    style="gap: 8px; padding: 7px 10px; border-radius: 4px; cursor: pointer; transition: background 0.15s ease;"
                    (click)="selectReassignUser(user, $event)">
                    @if (user.profileImg) {
                    <img [src]="user.profileImg" class="rounded-circle" width="22" height="22"
                      style="object-fit: cover; flex-shrink: 0;" (error)="user.profileImg = null" />
                    } @else {
                    <span class="d-inline-flex align-items-center justify-content-center rounded-circle"
                      style="width: 22px; height: 22px; background: #dbeafe; color: #1d4ed8; font-size: 11px; font-weight: 600; flex-shrink: 0;">
                      {{ (user.userName || 'U').charAt(0).toUpperCase() }}
                    </span>
                    }
                    <span class="text-truncate" style="font-size: 13px; color: #1e293b; font-weight: 500;">
                      {{ user.userName }}
                    </span>
                  </a>
                  }
                </div>
              </div>

              <!-- Reassign Button -->
              <button type="button" class="btn btn-primary d-inline-flex align-items-center justify-content-center"
                (click)="reassignLead()" [disabled]="!selectedReassignUser || isReassigning"
                style="height: 38px; padding: 0 16px; font-size: 13px; font-weight: 600; border-radius: 6px; white-space: nowrap; flex-shrink: 0;">
                @if (isReassigning) {
                <span class="spinner-border spinner-border-sm mr-1"></span>
                }
                Reassign
              </button>
            </div>
          </div>
          } @else {
          <!-- FOR SALES AND OTHER USERS: Standard Follow up assignee -->
          <div class="detail-row">
            <label>Follow up assignee</label><span class="colon">:</span>
            <div class="dropdown custom-dd assignee-dd ml-2" [class.show]="assigneeDropdownOpen">
              <button type="button"
                class="btn dropdown-toggle dd-btn w-100 d-flex align-items-center justify-content-between"
                (click)="toggleAssigneeDropdown($event)" [class.placeholder]="!selectedAssigneeName">
                <span class="assignee-text">
                  {{ selectedAssigneeName || "Select assignee" }}
                </span>

                @if (selectedAssigneeName) {
                <span class="clear-icon" (click)="clearAssignee($event)" title="Clear assignee">
                  ✕
                </span>
                }
              </button>

              <div class="dropdown-menu w-100 shadow-sm" [class.show]="assigneeDropdownOpen"
                style="max-height: 220px; overflow-y: auto; padding: 4px; border-radius: 6px; border: 1px solid #e2e8f0; z-index: 1050;">
                @for (user of salesUsers; track user._id || user.id || $index) {
                <a class="dropdown-item d-flex align-items-center"
                  style="gap: 8px; padding: 7px 10px; border-radius: 4px; cursor: pointer; transition: background 0.15s ease;"
                  (click)="
                      selectAssignee(user, $event);
                      assignLeadToUser(user, selectedLeadForDetails)
                    ">
                  @if (user.profileImg) {
                  <img [src]="user.profileImg" class="rounded-circle" width="22" height="22"
                    style="object-fit: cover; flex-shrink: 0;" (error)="user.profileImg = null" />
                  } @else {
                  <span class="d-inline-flex align-items-center justify-content-center rounded-circle"
                    style="width: 22px; height: 22px; background: #dbeafe; color: #1d4ed8; font-size: 11px; font-weight: 600; flex-shrink: 0;">
                    {{ (user.userName || 'U').charAt(0).toUpperCase() }}
                  </span>
                  }
                  <span class="text-truncate" style="font-size: 13px; color: #1e293b; font-weight: 500;">
                    {{ user.userName }}
                  </span>
                </a>
                }
              </div>
            </div>
          </div>
          }

          <div class="detail-row">
            <label>Status</label><span class="colon">:</span>
            <div class="dropdown custom-dd status-dd ml-2" [class.show]="statusDropdownOpen">
              <button type="button" class="btn dropdown-toggle dd-btn w-100" (click)="toggleStatusDropdown($event)"
                [disabled]="isStatusDropdownDisabled(selectedLead)"
                [class.disabled]="isStatusDropdownDisabled(selectedLead)">
                {{ selectedLeadStatus || "Select Status" }}
              </button>
              <div class="dropdown-menu w-100" [class.show]="statusDropdownOpen">
                @for (status of statusList; track status) {
                @if (status !== 'Closing Pool') {
                <a class="dropdown-item" [class.active]="selectedLeadStatus === status"
                  (click)="selectLeadStatus(status)">
                  {{ status }}
                </a>
                }
                }

              </div>
            </div>
          </div>

          <!-- Lost Reason Field -->
          @if (showLostReason) {
          <div class="detail-row">
            <label>Lost Reason</label><span class="colon">:</span>
            <textarea class="detail-textarea notes-box ml-2" rows="3" formControlName="lossReason"
              placeholder="Please specify the reason for losing this lead">
            </textarea>
          </div>
          }

          <div class="detail-row">
            <label>Source</label><span class="colon">:</span>
            <textarea class="detail-textarea notes-box ml-2" rows="2" style="height: 42px;"
              [value]="selectedLead?.source ? selectedLead?.source : '-'" readonly disabled>
            </textarea>
          </div>
          @if (selectedLead?.source?.toLowerCase() === 'whatsapp') {
          <div class="detail-row align-items-start">
            <label style="margin-top: 6px;">WhatsApp Messages</label><span class="colon"
              style="margin-top: 6px;">:</span>
            <div class="whatsapp-messages-box ml-2">
              <app-whatsapp-messages-card #salesWaCard [phoneNumber]="selectedLead?.phoneNo" [showHeader]="true"
                [showViewDetail]="true" (viewDetail)="viewWhatsAppDetail(selectedLead)"></app-whatsapp-messages-card>
            </div>
          </div>
          } @else {
          <div class="detail-row">
            <label>User Message</label><span class="colon">:</span>
            <textarea class="detail-textarea notes-box user-msg ml-2 " rows="5"
              [value]="getLeadDisplayMessage(selectedLead)" readonly disabled>
            </textarea>
          </div>
          }

          <!-- Badge Field -->
          <div class="detail-row">
            <label>Badge</label><span class="colon">:</span>
            @if (isAdmin) {
            <div class="dropdown custom-dd ml-2 badge-dd-container badge-dd badge-dropdown" [class.show]="badgeDropdownOpen"
              style="width: 275px !important;">
              <button type="button"
                class="btn dropdown-toggle dd-btn w-100 d-flex align-items-center justify-content-between"
                [class.badge-dd-active]="badgeDropdownOpen" (click)="toggleBadgeDropdown()"
                style="height: 42px; padding: 4px 12px;">
                @if (selectedBadgeDetails) {
                <span class="badge-pill {{ selectedBadgeDetails.class }}" style="margin: 0;">
                  {{ selectedBadgeDetails.label }}
                </span>
                } @else {
                <span style="margin: 0; color: #aaa">Select Badge</span>
                }

                @if (badgeDropdownOpen) {
                <span class="close-badge-dd ml-2" (click)="$event.stopPropagation(); badgeDropdownOpen = false"
                  title="Close">
                  ✕
                </span>
                } @else {
                <span class="dropdown-caret-icon ml-2">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 10l5 5 5-5H7z" fill="#888888" />
                  </svg>
                </span>
                }
              </button>

              <div class="dropdown-menu badge-items w-100" [class.show]="badgeDropdownOpen"
                style="width: 275px !important;">
                @for (badge of badgeOptions; track badge.value) {
                <div class="dropdown-item d-flex justify-content-between align-items-center"
                  (click)="selectBadgeDetails(badge.value)">
                  <span class="badge-pill {{ badge.class }}">
                    {{ badge.label }}
                  </span>
                  <input type="radio" class="badge-radio" [checked]="selectedBadgeDetails?.value === badge.value" />
                </div>
                }
              </div>
            </div>
            } @else {
            <div class="ml-2 d-flex align-items-center" style="height: 42px;">
              @if (selectedLead?.customerValue || selectedLead?.badge) {
              <span class="badge-pill {{ getBadgeClass(selectedLead?.customerValue || selectedLead?.badge) }}">
                {{ selectedLead?.customerValue || selectedLead?.badge }}
              </span>
              } @else {
              <span style="color: #aaa">-</span>
              }
            </div>
            }
          </div>

          <div class="detail-row">
            <label>Admin Notes</label><span class="colon">:</span>
            @if (isAdmin) {
            <textarea class="detail-textarea notes-box admin-notes ml-2" rows="5" formControlName="adminNotes"
              placeholder="Enter admin notes...">
            </textarea>
            } @else {
            <textarea class="detail-textarea notes-box admin-notes ml-2" rows="5" [value]="
                selectedLead?.adminNotes || selectedLead?.description || '-'
              " disabled readonly>
            </textarea>
            }
          </div>
          <hr class="canvas-divider" />

          <!-- INFINITE EDITOR -->
          <div class="notion-editor-container">

            <!-- FOLLOW UP TASK SECTION -->
            @if (canCreateFollowUpTask) {
            <div class="follow-up-task-container my-3 p-3" [class.follow-up-task-disabled]="isLeadLostOrUnqualified">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="follow-up-task-title">Follow up Task</span>
                @if (isLeadLost) {
                <span class="badge d-inline-flex align-items-center reminder-badge-disabled">
                  <i class="fas fa-lock" style="font-size: 11px;"></i>
                  Disabled for Lost
                </span>
                } @else if (isLeadUnqualified) {
                <span class="badge d-inline-flex align-items-center reminder-badge-disabled">
                  <i class="fas fa-lock" style="font-size: 11px;"></i>
                  Disabled for Unqualified
                </span>
                } @else if (hasActiveFollowUpTask) {
                <span class="badge d-inline-flex align-items-center follow-up-active-badge">
                  <i class="fas fa-clock" style="font-size: 11px;"></i>
                  Active Task In Progress
                </span>
                }
              </div>

              @if (hasActiveFollowUpTask && !isLeadLostOrUnqualified) {
              <div class="alert d-flex align-items-center mb-2 py-2 px-3 follow-up-active-alert">
                <i class="fas fa-exclamation-triangle" style="font-size: 13px; flex-shrink: 0;"></i>
                <span>Please wait until the current task is marked
                  as <strong>Done</strong> before creating a new follow-up task.
                </span>
              </div>
              }

              <div class="d-flex align-items-start mb-2 follow-up-task-input-row" style="gap: 12px;">
                <!-- Followup Assignee Dropdown -->
                <div class="dropdown custom-dd follow-up-assignee-dd position-relative"
                  [class.show]="followUpTaskAssigneeDropdownOpen && !hasActiveFollowUpTask && !isLeadLostOrUnqualified">
                  <button type="button"
                    class="btn dropdown-toggle dd-btn w-100 d-flex align-items-center justify-content-between follow-up-assignee-btn"
                    (click)="!hasActiveFollowUpTask && !isLeadLostOrUnqualified && toggleFollowUpTaskAssigneeDropdown($event)"
                    [class.placeholder]="!selectedFollowUpTaskAssignee" [disabled]="hasActiveFollowUpTask || isLeadLostOrUnqualified"
                    [style.opacity]="(hasActiveFollowUpTask || isLeadLostOrUnqualified) ? '0.65' : '1'"
                    [style.cursor]="(hasActiveFollowUpTask || isLeadLostOrUnqualified) ? 'not-allowed' : 'pointer'">
                    <div class="d-flex align-items-center text-truncate" style="gap: 8px;">
                      @if (selectedFollowUpTaskAssignee) {
                      @if (selectedFollowUpTaskAssignee.profileImg) {
                      <img [src]="selectedFollowUpTaskAssignee.profileImg" class="rounded-circle" width="22" height="22"
                        style="object-fit: cover; flex-shrink: 0;"
                        (error)="selectedFollowUpTaskAssignee.profileImg = null" />
                      } @else {
                      <span class="d-inline-flex align-items-center justify-content-center rounded-circle follow-up-assignee-avatar">
                        {{ (selectedFollowUpTaskAssignee.userName || selectedFollowUpTaskAssignee.name ||
                        'U').charAt(0).toUpperCase() }}
                      </span>
                      }
                      }
                      <span class="text-truncate follow-up-assignee-name">
                        {{ selectedFollowUpTaskAssignee?.userName || selectedFollowUpTaskAssignee?.name || 'Select
                        Assignee' }}
                      </span>
                    </div>
                    @if (selectedFollowUpTaskAssignee && !hasActiveFollowUpTask && !isLeadLostOrUnqualified) {
                    <span class="clear-icon ml-1" (click)="clearFollowUpTaskAssignee($event)" title="Clear assignee">✕</span>
                    }
                  </button>
                  @if (!hasActiveFollowUpTask && !isLeadLostOrUnqualified) {
                  <div class="dropdown-menu w-100 shadow-sm follow-up-assignee-menu" [class.show]="followUpTaskAssigneeDropdownOpen">
                    @for (user of salesUsers; track user) {
                    <a class="dropdown-item d-flex align-items-center"
                      (click)="selectFollowUpTaskAssignee(user, $event)"
                      style="gap: 8px; padding: 7px 10px; border-radius: 4px; cursor: pointer; transition: background 0.15s ease;">
                      @if (user.profileImg) {
                      <img [src]="user.profileImg" class="rounded-circle" width="22" height="22"
                        style="object-fit: cover; flex-shrink: 0;" (error)="user.profileImg = null" />
                      } @else {
                      <span class="d-inline-flex align-items-center justify-content-center rounded-circle follow-up-assignee-avatar">
                        {{ (user.userName || 'U').charAt(0).toUpperCase() }}
                      </span>
                      }
                      <span class="text-truncate follow-up-assignee-item-name">
                        {{ user.userName }}
                      </span>
                    </a>
                    }
                  </div>
                  }
                </div>

                <!-- Description Field -->
                <textarea class="form-control follow-up-task-desc"
                  [placeholder]="isLeadLost ? 'Follow up task is disabled for lost leads' : (isLeadUnqualified ? 'Follow up task is disabled for unqualified leads' : (hasActiveFollowUpTask ? 'Complete the current active task before creating a new follow-up task...' : 'Enter follow up task description...'))"
                  [(ngModel)]="followUpTaskDescription" [ngModelOptions]="{standalone: true}" rows="2"
                  [disabled]="hasActiveFollowUpTask || isLeadLostOrUnqualified" [style.opacity]="(hasActiveFollowUpTask || isLeadLostOrUnqualified) ? '0.65' : '1'"
                  [style.cursor]="(hasActiveFollowUpTask || isLeadLostOrUnqualified) ? 'not-allowed' : 'text'"></textarea>
              </div>

              <!-- Submit Task Button -->
              <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-primary d-inline-flex align-items-center justify-content-center"
                  (click)="submitFollowUpTask()"
                  [disabled]="!selectedFollowUpTaskAssignee || !followUpTaskDescription?.trim() || isSubmittingFollowUpTask || hasActiveFollowUpTask || isLeadLostOrUnqualified"
                  [title]="isLeadLost ? 'Follow up task is disabled for lost leads' : (isLeadUnqualified ? 'Follow up task is disabled for unqualified leads' : (hasActiveFollowUpTask ? 'An active follow-up task is currently in progress for this lead. Mark it as Done before adding a new task.' : (!selectedFollowUpTaskAssignee ? 'Please select an assignee' : (!followUpTaskDescription?.trim() ? 'Please enter a description' : 'Add Task'))))"
                  style="height: 38px; padding: 0 18px; font-size: 13px; font-weight: 600; border-radius: 6px;">
                  @if (isSubmittingFollowUpTask) {
                  <span class="spinner-border spinner-border-sm mr-1"></span>
                  }
                  Add Task
                </button>
              </div>
            </div>
            }

            <!-- ASSISTANT SALES FOLLOW-UP TASK ACTION BOX -->
            @if (canShowAssistantTaskActionBox) {
            <div class="assistant-task-action-box my-3 p-3">
              <!-- Task Notes Section -->
              <div>
                <!-- Task Notes Label -->
                <label class="d-block mb-1 assistant-task-label">
                  Follow up Task Notes
                </label>
                <!-- Task Notes Textarea -->
                <textarea class="form-control mb-3 assistant-task-textarea" placeholder="Enter task notes..." [(ngModel)]="assistantTaskNote"
                  [ngModelOptions]="{standalone: true}" rows="3"></textarea>

                <!-- Right Side Action Buttons -->
                <div class="d-flex align-items-center justify-content-end">
                  <!-- Mark as Done Button -->
                  <button type="button" class="btn btn-success d-inline-flex align-items-center justify-content-center"
                    (click)="markAssistantTaskDone()"
                    [disabled]="!assistantTaskNote?.trim() || !showReminderSection || !reminderDueAt || !reminderDueTime || isCompletingTask"
                    style="height: 38px; padding: 0 18px; font-size: 13px; font-weight: 600; border-radius: 6px;">
                    @if (isCompletingTask) {
                    <span class="spinner-border spinner-border-sm mr-1"></span>
                    }
                    Mark as Done
                  </button>
                </div>
              </div>
            </div>
            }

            @if (!isLeadClosed) {
            <!-- SET REMINDER SECTION (Displayed by default, disabled until status is set) -->
            <div class="reminder-task-container my-3 p-3" [class.reminder-task-disabled]="!showReminderSection || isLeadLostOrUnqualified">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex align-items-center" style="gap: 8px;">
                  <div class="d-flex align-items-center justify-content-center reminder-task-icon-wrapper">
                    <i class="fas fa-bell" style="font-size: 13px;"></i>
                  </div>
                  <span class="reminder-task-title">
                    Set Reminder for {{ isLeadLost ? 'Lost' : (isLeadUnqualified ? 'Unqualified' : (selectedReminderStatus || pendingReminderTargetStatus || selectedLead?.status ||
                    'Disposition')) }}
                  </span>
                </div>
                @if (isLeadLost) {
                <span class="badge d-inline-flex align-items-center reminder-badge-disabled">
                  <i class="fas fa-lock" style="font-size: 11px;"></i>
                  Disabled for Lost
                </span>
                } @else if (isLeadUnqualified) {
                <span class="badge d-inline-flex align-items-center reminder-badge-disabled">
                  <i class="fas fa-lock" style="font-size: 11px;"></i>
                  Disabled for Unqualified
                </span>
                } @else if (!showReminderSection) {
                <span class="badge d-inline-flex align-items-center reminder-badge-disabled">
                  <i class="fas fa-lock" style="font-size: 11px;"></i>
                  Set status to enable
                </span>
                } @else {
                <span class="badge d-inline-flex align-items-center"
                  [style.background]="(reminderDueAt && reminderDueTime) ? '#dcfce7' : '#fee2e2'"
                  [style.color]="(reminderDueAt && reminderDueTime) ? '#15803d' : '#b91c1c'"
                  [style.border]="(reminderDueAt && reminderDueTime) ? '1px solid #bbf7d0' : '1px solid #fecaca'"
                  style="font-size: 12px; font-weight: 500; padding: 4px 10px; border-radius: 12px; gap: 5px;">
                  <i [class]="(reminderDueAt && reminderDueTime) ? 'fas fa-check' : 'fas fa-clock'"
                    style="font-size: 11px;"></i>
                  {{ (reminderDueAt && reminderDueTime) ? 'Due date & time selected' : (canShowAssistantTaskActionBox ?
                  'Date & time required to complete' : 'Date & time required to save') }}
                </span>
                }
              </div>

              <p class="mb-3 reminder-task-subtitle">
                @if (isLeadLost) {
                Reminders are disabled for lost leads.
                } @else if (isLeadUnqualified) {
                Reminders are disabled for unqualified leads.
                } @else if (!showReminderSection) {
                Select or update the disposition status below to enable setting a follow-up reminder.
                } @else {
                Please select a status, reminder due date, and time below to
                enable {{ canShowAssistantTaskActionBox ? 'completing the follow-up task' : 'saving changes' }}.
                }
              </p>

              <div class="d-flex align-items-center w-100 reminder-inputs-row" style="gap: 12px;">
                <!-- Status Dropdown (Left) -->
                <div class="dropdown custom-dd reminder-status-dd position-relative"
                  [class.show]="reminderStatusDropdownOpen && showReminderSection && !isLeadLostOrUnqualified" style="flex: 1 1 0; min-width: 0;">
                  <button type="button"
                    class="btn dropdown-toggle dd-btn w-100 d-flex align-items-center justify-content-between reminder-status-btn"
                    [disabled]="!showReminderSection || isLeadLostOrUnqualified"
                    [style.cursor]="(!showReminderSection || isLeadLostOrUnqualified) ? 'not-allowed' : 'pointer'"
                    (click)="showReminderSection && !isLeadLostOrUnqualified && toggleReminderStatusDropdown($event)">
                    <div class="d-flex align-items-center text-truncate" style="gap: 8px;">
                      @if (selectedReminderStatusIcon || (isLeadLost && getStatusIcon('Lost')) || (isLeadUnqualified && getStatusIcon('Unqualified'))) {
                      <img [src]="selectedReminderStatusIcon || (isLeadLost ? getStatusIcon('Lost') : getStatusIcon('Unqualified'))" class="status-icon" alt="status" width="22" height="22"
                        style="flex-shrink: 0;" />
                      }
                      <span class="text-truncate reminder-status-btn-text">{{ isLeadLost ? 'Lost' : (isLeadUnqualified ? 'Unqualified' : (selectedReminderStatus ||
                        pendingReminderTargetStatus || 'Select Status')) }}</span>
                    </div>
                  </button>
                  @if (showReminderSection && !isLeadLostOrUnqualified) {
                  <div class="dropdown-menu w-100 shadow-sm reminder-status-menu" [class.show]="reminderStatusDropdownOpen">
                    @for (tab of canvasTabs; track tab.id || $index) {
                    @if (tab.label !== 'Unqualified' && tab.label !== 'Lost' && tab.label !== 'Follow-up Task' && tab.label !== 'Closing Pool')
                    {
                    <a class="dropdown-item d-flex align-items-center"
                      [class.active]="(selectedReminderStatus || pendingReminderTargetStatus) === tab.label"
                      (click)="selectReminderStatus(tab.label, $event)">
                      <img [src]="tab.icon" class="status-icon mr-2" alt="{{ tab.label }}" width="22" height="22" />
                      <span>{{ tab.label }}</span>
                    </a>
                    }
                    }
                  </div>
                  }
                </div>

                <!-- Date Input (Middle) -->
                <div class="position-relative" style="flex: 1 1 0; min-width: 0;">
                  <input type="date" class="form-control reminder-due-input w-100" [(ngModel)]="reminderDueAt"
                    [ngModelOptions]="{standalone: true}" [min]="todayDate" [disabled]="!showReminderSection || isLeadLostOrUnqualified"
                    [style.cursor]="(!showReminderSection || isLeadLostOrUnqualified) ? 'not-allowed' : 'text'" />
                  @if (reminderDueAt && showReminderSection && !isLeadLostOrUnqualified) {
                  <button type="button" class="clear-btn" (click)="reminderDueAt = ''" title="Clear date"
                    style="right: 32px;">
                    <i class="fas fa-times"></i>
                  </button>
                  }
                </div>

                <!-- Time Input (Right) -->
                <div class="position-relative" style="flex: 1 1 0; min-width: 0;">
                  <input type="time" class="form-control reminder-time-input w-100" [(ngModel)]="reminderDueTime"
                    [ngModelOptions]="{standalone: true}" [disabled]="!showReminderSection || isLeadLostOrUnqualified"
                    [style.cursor]="(!showReminderSection || isLeadLostOrUnqualified) ? 'not-allowed' : 'text'" />
                  @if (reminderDueTime && showReminderSection && !isLeadLostOrUnqualified) {
                  <button type="button" class="clear-btn" (click)="reminderDueTime = ''" title="Clear time"
                    style="right: 35px;">
                    <i class="fas fa-times"></i>
                  </button>
                  }
                </div>
              </div>
            </div>

            <!-- DISPOSITION -->
            <div class="disposition-container">
              <div class="d-flex align-items-center mb-2 disposition-action-row" style="gap: 12px;">
                <!-- Status Dropdown -->
                <div class="dropdown custom-dd disposition-status-dd position-relative"
                  [class.show]="dispositionStatusDropdownOpen">
                  <button type="button"
                    class="btn dropdown-toggle dd-btn w-100 d-flex align-items-center justify-content-between"
                    (click)="toggleDispositionStatusDropdown($event)"
                    style="height: 44px; font-size: 13.5px; background: #ffffff; border: 1px solid #dcdcdc; border-radius: 6px;">
                    <div class="d-flex align-items-center">
                      @if (selectedStatusIcon) {
                      <img [src]="selectedStatusIcon" class="status-icon mr-2" alt="status" width="24" height="24" />
                      }
                      <span>{{ selectedDispositionStatus || 'Select Status' }}</span>
                    </div>
                  </button>
                  <div class="dropdown-menu w-100 shadow-sm" [class.show]="dispositionStatusDropdownOpen"
                    style="max-height: 260px; overflow-y: auto; z-index: 1060;">
                    @for (tab of canvasTabs; track tab.id || $index) {
                    @if (tab.label !== 'Follow-up Task' && tab.label !== 'Closing Pool')
                    {
                    <a class="dropdown-item d-flex align-items-center"
                      [class.active]="selectedDispositionStatus === tab.label"
                      (click)="selectDispositionStatus(tab.label, $event)">
                      <img [src]="tab.icon" class="status-icon mr-2" alt="{{ tab.label }}" width="24" height="24" />
                      <span>{{ tab.label }}</span>
                    </a>
                    }
                    }
                  </div>
                </div>

                <!-- Remarks Input & Add Button -->
                <div class="disposition-input-wrapper flex-grow-1">
                  <textarea class="disposition-input w-100" placeholder="Enter disposition note"
                    [formControl]="dispositionControl" (input)="onDispositionTyping($event)"
                    (keydown.enter)="onDispositionEnter($event)" rows="1"></textarea>
                  <button type="button" class="disposition-add-btn" (click)="addDisposition()"
                    [disabled]="!isAddDispositionEnabled || isAddingDisposition" [class.btn-disabled]="!isAddDispositionEnabled || isAddingDisposition">
                    @if (isAddingDisposition) {
                    <span class="spinner-border spinner-border-sm" style="width: 16px; height: 16px; border-width: 2px;"></span>
                    } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path fill="none" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"
                        stroke-width="2" d="M12 6v12m6-6H6" />
                    </svg>
                    }
                  </button>
                </div>
              </div>

              <!-- DISPOSITION & ACTIVITY LIST  -->
              @if (formattedDispositions.length) {
              <div class="disposition-flow mt-3">

                @for (item of formattedDispositions; track item._id || item.id || $index; let i = $index) {

                <!-- FOLLOW-UP TASK EVENT -->
                @if (item.isFollowUpTaskEvent) {
                <div class="disposition-item my-4">
                  <p class="disposition-index" style="font-weight: 600; color: #64748b;">{{ item.seqNo || (i + 1) }}.
                  </p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="d-flex align-items-center" style="gap: 6px;">
                      <img src="/assets/leads/follow-up-task.svg" class="status-icon" alt="Followup Task" width="24"
                        height="24" style="flex-shrink: 0;" />
                      <span class="user-name" style="color: #334155; font-size: 15px; font-weight: 700;">Followup
                        Task</span>
                    </div>
                    <div class="date-text" style="font-size: 12px; color: #64748b; margin-top: 2px; margin-left: 3px;">
                      {{ (item.timestamp || item.updatedAt || item.createdAt) | date:'dd MMM , hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only d-flex flex-column align-items-start"
                    style="gap: 6px;">
                    @if (item.logType === 'completed') {
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px;">
                      <!-- ASSISTANT SALES USER NAME -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assigneeProfileImg) {
                        <img [src]="item.assigneeProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assigneeProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.assigneeName }}
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- DONE TAG -->
                      <span class="status-pill done-status d-flex align-items-center"
                        style="font-weight: 600; color: #166534; background: #dcfce7; border: 1px solid #bbf7d0; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        <i class="fas fa-check-circle" style="color: #16a34a; font-size: 12px;"></i>
                        Done
                      </span>
                    </div>

                    @if (item.note) {
                    <div class="task-desc-note mt-1">
                      <span style="font-weight: 600!important; color: #475569;">Note :</span> {{ item.note }}
                    </div>
                    }
                    } @else if (item.logType === 'updated') {
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px;">
                      <!-- ASSISTANT SALES USER NAME -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assigneeProfileImg) {
                        <img [src]="item.assigneeProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assigneeProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.assigneeName }}
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- UPDATED TAG -->
                      <span class="status-pill update-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e40af; background: #e0f2fe; border: 1px solid #bae6fd; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        <i class="fas fa-sync-alt" style="color: #2563eb; font-size: 11px;"></i>
                        Updated
                      </span>
                    </div>

                    @if (item.note) {
                    <div class="task-desc-note mt-1">
                      <span style="font-weight: 600!important; color: #475569;">Note :</span> {{ item.note }}
                    </div>
                    }
                    } @else {
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px;">
                      <!-- ASSIGNED BY -->
                      <span class="status-pill prev-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #e2e8f0; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assignedByProfileImg) {
                        <img [src]="item.assignedByProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assignedByProfileImg = null" />
                        } @else {
                        <i class="fas fa-user-circle" style="color: #64748b; font-size: 11px;"></i>
                        }
                        {{ item.assignedByName }}
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- ASSIGNEE -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assigneeProfileImg) {
                        <img [src]="item.assigneeProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assigneeProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.assigneeName }}
                      </span>
                    </div>

                    @if (item.note) {
                    <div class="task-desc-note mt-1">
                      <span style="font-weight: 600!important; color: #475569;">Task :</span> {{ item.note }}
                    </div>
                    }
                    }
                  </div>
                </div>
                }

                <!-- LEAD REASSIGNED EVENT -->
                @else if (item.isLeadReassignedEvent) {
                <div class="disposition-item my-4">
                  <p class="disposition-index" style="font-weight: 600; color: #64748b;">{{ item.seqNo || (i + 1) }}.
                  </p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name" style="color: #334155; font-size: 15px; font-weight: 700;">
                      {{ item.reassignedByName || 'System' }}
                    </div>
                    <div class="date-text" style="font-size: 12px; color: #64748b; margin-top: 2px;">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM , hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only d-flex flex-column align-items-start"
                    style="gap: 6px;">
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px; margin-top: 6px;">
                      <!-- REASSIGNED BY -->
                      <span class="status-pill prev-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #e2e8f0; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.reassignedByProfileImg) {
                        <img [src]="item.reassignedByProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.reassignedByProfileImg = null" />
                        } @else {
                        <i class="fas fa-user-circle" style="color: #64748b; font-size: 11px;"></i>
                        }
                        {{ item.reassignedByName || 'System' }}
                      </span>

                      <!-- ARROW LINE WITH MESSAGE ABOVE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-message-label">
                          <b class="event-prefix" style="font-weight: 700; color: #0f172a;">Reassigned :</b> {{
                          item.reassignedByName }} reassigned lead to {{ item.reassignedToName }}
                        </span>
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- REASSIGNED TO -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.reassignedToProfileImg) {
                        <img [src]="item.reassignedToProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.reassignedToProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.reassignedToName }}
                      </span>
                    </div>
                  </div>
                </div>
                }

                <!-- LEAD FOLLOW UP ASSIGNED EVENT -->
                @else if (item.isLeadFollowUpAssignedEvent) {
                <div class="disposition-item my-4">
                  <p class="disposition-index" style="font-weight: 600; color: #64748b;">{{ item.seqNo || (i + 1) }}.
                  </p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name" style="color: #334155; font-size: 15px; font-weight: 700;">
                      {{ item.assignedByName || 'System' }}
                    </div>
                    <div class="date-text" style="font-size: 12px; color: #64748b; margin-top: 2px;">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM , hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only d-flex flex-column align-items-start"
                    style="gap: 6px;">
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px; margin-top: 6px;">
                      <!-- ASSIGNED BY -->
                      <span class="status-pill prev-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #e2e8f0; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assignedByProfileImg) {
                        <img [src]="item.assignedByProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assignedByProfileImg = null" />
                        } @else {
                        <i class="fas fa-user-circle" style="color: #64748b; font-size: 11px;"></i>
                        }
                        {{ item.assignedByName || 'System' }}
                      </span>

                      <!-- ARROW LINE WITH MESSAGE ABOVE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-message-label">
                          <b class="event-prefix" style="font-weight: 700; color: #0f172a;">Follow-up Assigned :</b> {{
                          item.assignedByName }} assigned follow-up to {{ item.assignedToName }}
                        </span>
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- ASSIGNED TO -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assignedToProfileImg) {
                        <img [src]="item.assignedToProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assignedToProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.assignedToName }}
                      </span>
                    </div>

                    @if (item.note) {
                    <div class="task-desc-note mt-1">
                      <span style="font-weight: 600!important; color: #475569;">Note :</span> {{ item.note }}
                    </div>
                    }
                  </div>
                </div>
                }

                <!-- LEAD ASSIGNED EVENT -->
                @else if (item.isLeadAssignedEvent) {
                <div class="disposition-item my-4">
                  <p class="disposition-index" style="font-weight: 600; color: #64748b;">{{ item.seqNo || (i + 1) }}.
                  </p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name" style="color: #334155; font-size: 15px; font-weight: 700;">
                      {{ item.assignedByName || 'System' }}
                    </div>
                    <div class="date-text" style="font-size: 12px; color: #64748b; margin-top: 2px;">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM , hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only d-flex flex-column align-items-start"
                    style="gap: 6px;">
                    <div class="status-arrow-wrapper d-flex align-items-center" style="gap: 8px; margin-top: 6px;">
                      <!-- ASSIGNED BY -->
                      <span class="status-pill prev-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #e2e8f0; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assignedByProfileImg) {
                        <img [src]="item.assignedByProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assignedByProfileImg = null" />
                        } @else {
                        <i class="fas fa-user-circle" style="color: #64748b; font-size: 11px;"></i>
                        }
                        {{ item.assignedByName || 'System' }}
                      </span>

                      <!-- ARROW LINE WITH MESSAGE ABOVE -->
                      <span class="status-arrow-line" style="margin: 0 4px;">
                        <span class="arrow-message-label">
                          <b class="event-prefix" style="font-weight: 700; color: #0f172a;">Lead Assigned :</b> {{
                          item.assignedByName }} assigned lead to {{ item.assignedToName }}
                        </span>
                        <span class="arrow-head" style="color: #94a3b8;">▶</span>
                      </span>

                      <!-- ASSIGNED TO -->
                      <span class="status-pill current-status d-flex align-items-center"
                        style="font-weight: 600; color: #1e293b; background: #dbeafe; padding: 4px 12px; border-radius: 16px; font-size: 13px; gap: 6px;">
                        @if (item.assignedToProfileImg) {
                        <img [src]="item.assignedToProfileImg" class="rounded-circle" width="18" height="18"
                          style="object-fit: cover; flex-shrink: 0;" (error)="item.assignedToProfileImg = null" />
                        } @else {
                        <i class="fas fa-user" style="color: #2563eb; font-size: 11px;"></i>
                        }
                        {{ item.assignedToName }}
                      </span>
                    </div>
                  </div>
                </div>
                }

                <!-- SYSTEM CLOSING POOL UPDATE -->
                @else if (
                item.isClosingPoolEvent ||
                (item.type === 'System' && (item.event === 'Closing Pool Update' || item.hasClosingPotential !==
                undefined))
                ) {
                <div class="disposition-item my-3">

                  <!-- INDEX -->
                  <p class="disposition-index">{{ item.seqNo || (i + 1) }}.</p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name" style="color: grey;font-size: 18px;">System</div>

                    <div class="date-text">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM , hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only">
                    <div class="status-arrow-wrapper">

                      @if (isClosingPoolAdded(item)) {
                      <!-- PREVIOUS STAGE STATUS -->
                      <span class="status-pill prev-status d-flex align-items-center">
                        @if(getStatusIcon(getLeadStageStatus(item))){
                        <img [src]="getStatusIcon(getLeadStageStatus(item))" class="status-icon mr-1" alt="prev status"
                          width="30" />
                        }
                        {{ getLeadStageStatus(item) }}
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line">
                        <span class="arrow-head">▶</span>
                      </span>

                      <!-- ADDED TO CLOSING POOL -->
                      <span class="status-pill current-status d-flex align-items-center closing-pool-added-pill">
                        <span class="mr-1">🦄</span>
                        Closing Pool
                      </span>
                      } @else {
                      <!-- FROM CLOSING POOL -->
                      <span class="status-pill prev-status d-flex align-items-center closing-pool-removed-pill">
                        <span class="mr-1">🦄</span>
                        Closing Pool
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line">
                        <span class="arrow-head">▶</span>
                      </span>

                      <!-- TO STAGE STATUS -->
                      <span class="status-pill current-status d-flex align-items-center">
                        @if(getStatusIcon(getLeadStageStatus(item))){
                        <img [src]="getStatusIcon(getLeadStageStatus(item))" class="status-icon mr-1"
                          alt="current status" width="30" />
                        }
                        {{ getLeadStageStatus(item) }}
                      </span>
                      }

                    </div>
                  </div>

                </div>
                }

                <!-- SYSTEM STATUS CHANGE / STATUS UPDATE -->
                @else if (
                item.isStatusUpdateEvent ||
                (item.type === 'System' && item.status && item.prevStatus !== item.status)
                ) {
                <div class="disposition-item my-3">

                  <!-- INDEX -->
                  <p class="disposition-index">{{ item.seqNo || (i + 1) }}.</p>

                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name" style="color: grey;font-size: 18px;">System</div>

                    <div class="date-text">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM , hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-system-right status-only">
                    <div class="status-arrow-wrapper">

                      <!-- PREVIOUS STATUS -->
                      <span class="status-pill prev-status d-flex align-items-center">
                        @if(getStatusIcon(item.prevStatus)){
                        <img [src]="getStatusIcon(item.prevStatus)" class="status-icon mr-1" alt="prev status"
                          width="30" />
                        }
                        {{ item.prevStatus || '-' }}
                      </span>

                      <!-- ARROW LINE -->
                      <span class="status-arrow-line">
                        <span class="arrow-head">▶</span>
                      </span>

                      <!-- CURRENT STATUS -->
                      <span class="status-pill current-status d-flex align-items-center">
                        @if(getStatusIcon(item.status)){
                        <img [src]="getStatusIcon(item.status)" class="status-icon mr-1" alt="current status"
                          width="30" />
                        }
                        {{ item.status }}
                      </span>

                    </div>
                  </div>

                </div>
                }

                <!-- USER NOTE / GENERAL DISPOSITION -->
                @else if (item.note) {
                <div class="disposition-item my-3">
                  <p class="disposition-index"> {{ item.seqNo || (i + 1) }}. </p>
                  <!-- LEFT BOX -->
                  <div class="disposition-left">
                    <div class="user-name">
                      {{ item.userName || '-' }}
                    </div>

                    @if (item.status) {
                    <div class="status-text d-flex align-items-center">
                      @if (getStatusIcon(item.status)) {
                      <img [src]="getStatusIcon(item.status)" class="status-icon mr-1" alt="status" width="25" />
                      }
                      <p class="mb-0">
                        {{ item.status }} </p>
                    </div>
                    }

                    <div class="date-text">
                      {{ (item.updatedAt || item.createdAt || item.timestamp) | date:'dd MMM , hh:mm a' }}
                    </div>
                  </div>

                  <!-- RIGHT BOX -->
                  <div class="disposition-right">
                    <div class="disposition-note">
                      <p class="note-placeholder mb-0">Note:</p>
                      {{ item.note }}
                    </div>
                  </div>

                </div>
                }

                }

              </div>
              }


            </div>

            <hr class="disposition-divider" />
            }

            <div class="editor-blocks mt-3" (drop)="onFileDrop($event)" (dragover)="onEditorDragOver($event)"
              (dragenter)="onEditorDragEnter($event)">
              @for (block of editorBlocks; track block.id; let i = $index) {

              <!-- TEXT BLOCK -->
              @if (block.type === 'text') {
              <div class="editor-block" (click)="focusTextBlock(i, $event)" [attr.data-block-id]="block.id">
                <textarea placeholder="Ask or find anything from your workspace..." #editorTextarea
                  class="editor-textarea" [value]="block.value" (input)="onTextBlockInput($event, i)"
                  (keydown)="onEditorKeydown($event, block, i)" (click)="$event.stopPropagation()"
                  [attr.data-block-id]="block.id">
              </textarea>
              </div>
              }
              @if(block.type === 'text' && block.value && block.value.length > 120){
              <button class="expand-btn" type="button" (click)="expandTextBlock(i)">
                {{ expandedTextBlocks[i] ? 'show Less' : 'show More' }}
              </button>
              }
              <!-- FILE BLOCK -->
              @if (block.type === 'file') {
              <div class="editor-file-block">
                <!-- UPLOAD PROGRESS WRAPPER (VISIBLE WHILE UPLOADING) -->
                <span class="file-delete-icon" (click)="onDeleteFile(block, i, $event)" title="Remove file">
                  ✕
                </span>

                @if (block.uploading) {
                <div class="upload-progress-container">
                  <div class="upload-progress-bar">
                    <div class="upload-progress-fill" [style.width.%]="block.progress"></div>
                  </div>

                  <span class="upload-progress-text">
                    Uploading {{ block.progress }}%
                  </span>
                </div>
                }

                <!-- IMAGE PREVIEW -->
                @if (['jpg','jpeg','png','gif','webp'].includes(block.extension
                || '') && block.url) {
                <img class="preview-img" [src]="block.url" alt="image preview" (click)="openFullscreen(block)" />
                }

                <!-- VIDEO PREVIEW -->
                @if (['mp4','mov','webm','mkv'].includes(block.extension || '')
                && block.url) {
                <video class="preview-video" [poster]="block.thumbnailUrl" [src]="block.url" controls preload="metadata"
                  (click)="openFullscreen(block)"></video>

                }

                <!-- DOC / PDF / OTHER FILES -->
                @if
                (!['jpg','jpeg','png','gif','webp','mp4','mov','webm','mkv'].includes(block.extension
                || '')) {
                <div class="file-doc-block d-flex align-items-center gap-3" (click)="openFullscreen(block)">
                  <img class="doc-icon" src="/assets/leads/document-files-icon.png" width="50" height="50"
                    alt="Document" />
                  <div class="doc-meta ml-2">
                    <p class="file-doc-name mb-1">{{ block.fileName }}</p>
                    <p class="file-doc-date mb-0">
                      {{ block.uploadedAt | date : "dd MMM yyyy" }} •
                      {{ block.uploadedAt | date : "hh:mm a" }}
                    </p>
                  </div>
                </div>
                }
              </div>
              } }


              <div class="editor-bottom-space" (click)="focusLastTextBlock()"></div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  }

  <!-- Logo upload modal -->
  @if (showLogoUploadModal) {
  <div class="upload-modal-backdrop" (click)="closeUploadLogoModal()"></div>
  <div class="upload-modal" [class.cropper-active]="showCropper" (click)="$event.stopPropagation()">
    <div class="upload-modal-header">
      <h3>Upload Logo</h3>
      <button type="button" class="close-btn" (click)="closeUploadLogoModal()">
        ✕
      </button>
    </div>

    <div class="upload-modal-body">
      @if (!showCropper) {
      <label class="upload-drop-area w-100" (click)="$event.stopPropagation()">
        @if (!logoPreview) {
        <div class="logo-placeholder mt-2">
          <img src="../../../../assets/upload-icon.png" width="30" height="30" alt="">
          <span>Click to upload</span>
        </div>
        } @if (logoPreview) {
        <img class="logo-preview-img" [src]="logoPreview" alt="preview" />
        }
        <input type="file" accept="image/*" hidden (change)="onLogoSelect($event)" />
      </label>

      @if (logoPreview) {
      <button type="button" class="gradient-btn" style="margin: 5px auto" (click)="saveLogo()">
        Upload Logo
      </button>
      }
      } @else {
      <div class="cropper-wrapper w-100 text-center">
        <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1 / 1"
          [roundCropper]="true" [resizeToWidth]="256" [transform]="transform" [containWithinAspectRatio]="false"
          format="png" (imageCropped)="imageCropped($event)"
          style="width: 100%; height: 350px; display: block; margin: 0 auto;"></image-cropper>

        <div class="zoom-controls d-flex justify-content-center align-items-center mt-2 mb-2" style="gap: 15px;">
          <button type="button" (click)="zoomOut()">
            <i class="fas fa-minus mr-1"></i> Zoom Out
          </button>
          <button type="button" (click)="zoomIn()">
            <i class="fas fa-plus mr-1"></i> Zoom In
          </button>
        </div>

        <div class="d-flex justify-content-center gap-2 mt-3" style="gap: 10px;">
          <!-- <button type="button" class="btn btn-secondary px-3" (click)="cancelCrop()">Cancel</button> -->
          <button type="button" class="gradient-btn py-2 px-4" (click)="saveCrop()">Crop & Save</button>
        </div>
      </div>
      }
    </div>
  </div>
  }

  <!-- FULLSCREEN PREVIEW MODAL -->
  @if (fullscreenPreview) {
  <div class="fs-backdrop" (click)="closeFullscreen()"></div>

  <div class="fs-container">
    <!-- CLOSE BUTTON -->
    <div class="d-flex align-items-center">
      <button class="fs-close" (click)="closeFullscreen()">✕</button>
      <svg (click)="downloadFile(fullscreenPreview)" class="fs-download-btn mr-2" xmlns="http://www.w3.org/2000/svg"
        width="2.5rem" height="2.5rem" viewBox="0 0 24 24">
        <path fill="#fff"
          d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z" />
      </svg>
    </div>
    <!-- IMAGE PREVIEW -->
    @if (fullscreenPreview.type === 'image') {
    <img class="fs-image" [src]="fullscreenPreview.url" />
    }

    <!-- VIDEO PREVIEW -->
    @if (fullscreenPreview.type === 'video') {
    <video class="fs-video" [src]="fullscreenPreview.url" controls autoplay></video>
    }

    <!-- DOCUMENT PREVIEW -->
    @if (fullscreenPreview.type === 'document') {
    <div class="fs-doc-preview">
      <img src="/assets/leads/document-files-icon.png" width="80" />
      <p class="file-name-text">{{ fullscreenPreview.fileName }}</p>
    </div>
    }
  </div>
  }
</div>

<!-- USER ALERT MODAL OVERLAY -->
@if (userAlertModal.show) {
<div class="user-alert-overlay d-flex align-items-center justify-content-center" (click)="closeAlertModal()">
  <div class="user-alert-card" (click)="$event.stopPropagation()">
    <div class="user-alert-icon" [class.warning]="userAlertModal.type === 'warning'"
      [class.error]="userAlertModal.type === 'error'" [class.success]="userAlertModal.type === 'success'">
      @if (userAlertModal.type === 'warning' || userAlertModal.type === 'error') {
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
      } @else {
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
      }
    </div>
    <h4 class="user-alert-title">{{ userAlertModal.title }}</h4>
    <p class="user-alert-message">{{ userAlertModal.message }}</p>
    <div class="user-alert-footer">
      <button type="button" class="btn-alert-ok" (click)="closeAlertModal()">OK</button>
    </div>
  </div>
</div>
}
} }

<!-- CREATE OUTBOUND LEAD MODAL OVERLAY -->
@if (showCreateOutboundModal) {
<div class="outbound-modal-overlay d-flex align-items-center justify-content-center">
  <div class="outbound-modal-card" (click)="$event.stopPropagation()">
    <!-- MODAL HEADER -->
    <div class="outbound-modal-header d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center" style="gap: 12px;">
        <div class="outbound-modal-icon-badge">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="8.5" cy="7" r="4"></circle>
            <line x1="20" y1="8" x2="20" y2="14"></line>
            <line x1="17" y1="11" x2="23" y2="11"></line>
          </svg>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold" style="font-size: 18px; color: #0f172a;">{{ isEditOutboundMode ? 'Edit Lead'
            : 'Create Lead' }}</h5>
          <span class="text-muted small">{{ isEditOutboundMode ? 'Update details of the outbound lead' : 'Enter details
            to create a new lead' }}</span>
        </div>
      </div>
      <button type="button" class="btn-close-sq" (click)="closeCreateOutboundLeadModal()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="outbound-modal-divider"></div>

    <!-- MODAL BODY FORM -->
    <div class="outbound-modal-body">
      @if (outboundErrorMessage) {
      <div class="outbound-alert-banner warning d-flex align-items-center justify-content-between mb-3">
        <div class="d-flex align-items-center" style="gap: 10px;">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <span>{{ outboundErrorMessage }}</span>
        </div>
        <button type="button" class="btn-close-alert" (click)="outboundErrorMessage = ''">&times;</button>
      </div>
      }

      <div class="outbound-form-grid">
        <!-- Name -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Name <span class="text-danger">*</span></label>
          <input type="text" name="name" class="custom-input"
            [class.is-invalid]="outboundErrorMessage && !outboundForm.name?.trim()" placeholder="Enter name"
            [(ngModel)]="outboundForm.name"
            (input)="outboundForm.name = $any($event.target).value; outboundErrorMessage = ''" />
        </div>

        <!-- Email -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Email</label>
          <input type="email" name="email" class="custom-input" placeholder="Enter email"
            [(ngModel)]="outboundForm.email" (input)="outboundForm.email = $any($event.target).value" />
        </div>

        <!-- Company Name -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Company Name</label>
          <input type="text" name="companyName" class="custom-input" placeholder="Enter company name"
            [(ngModel)]="outboundForm.companyName" (input)="outboundForm.companyName = $any($event.target).value" />
        </div>

        <!-- Designation -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Designation</label>
          <input type="text" name="designation" class="custom-input" placeholder="Enter designation"
            [(ngModel)]="outboundForm.designation" (input)="outboundForm.designation = $any($event.target).value" />
        </div>

        <!-- Phone Number -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Phone Number</label>
          <input type="tel" name="phoneNo" class="custom-input" placeholder="Enter phone number"
            [(ngModel)]="outboundForm.phoneNo" (input)="outboundForm.phoneNo = $any($event.target).value" />
        </div>

        <!-- Source -->
        <div class="outbound-field-group">
          <label class="outbound-field-label">Source</label>
          <input type="text" name="source" class="custom-input" value="Outbound" readonly disabled
            [(ngModel)]="outboundForm.source" />
        </div>

        <!-- Message -->
        <div class="outbound-field-group outbound-field-full">
          <label class="outbound-field-label">Message</label>
          <textarea name="message" class="custom-textarea" rows="3" placeholder="Enter message..."
            [(ngModel)]="outboundForm.message" (input)="outboundForm.message = $any($event.target).value"></textarea>
        </div>
      </div>
    </div>

    <!-- MODAL FOOTER -->
    <div class="outbound-modal-footer">
      <button type="button" class="gradient-btn" [disabled]="isSubmittingOutbound" (click)="submitCreateOutboundLead()">
        @if (isSubmittingOutbound) {
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span>{{ isEditOutboundMode ? 'Updating...' : 'Submitting...' }}</span>
        } @else {
        <span>{{ isEditOutboundMode ? 'Update' : 'Submit' }}</span>
        }
      </button>
    </div>
  </div>
</div>
}